import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Long` scalar type represents 52-bit integers */
  Long: any;
  /** A time string with format: HH:mm:ss.SSS */
  Time: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
};

export type CategoriaInput = {
  Nombre?: Maybe<Scalars['String']>;
  productos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Hombre?: Maybe<Scalars['Boolean']>;
  Mujer?: Maybe<Scalars['Boolean']>;
  CategoriaDestacada?: Maybe<Scalars['Boolean']>;
  MostrarEnMenu?: Maybe<Scalars['Boolean']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Categorias = {
  __typename?: 'Categorias';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Nombre?: Maybe<Scalars['String']>;
  Hombre?: Maybe<Scalars['Boolean']>;
  Mujer?: Maybe<Scalars['Boolean']>;
  CategoriaDestacada?: Maybe<Scalars['Boolean']>;
  MostrarEnMenu?: Maybe<Scalars['Boolean']>;
  published_at?: Maybe<Scalars['DateTime']>;
  productos?: Maybe<Array<Maybe<Productos>>>;
};


export type CategoriasProductosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CategoriasAggregator = {
  __typename?: 'CategoriasAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CategoriasConnection = {
  __typename?: 'CategoriasConnection';
  values?: Maybe<Array<Maybe<Categorias>>>;
  groupBy?: Maybe<CategoriasGroupBy>;
  aggregate?: Maybe<CategoriasAggregator>;
};

export type CategoriasConnectionCategoriaDestacada = {
  __typename?: 'CategoriasConnectionCategoriaDestacada';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CategoriasConnection>;
};

export type CategoriasConnectionCreated_At = {
  __typename?: 'CategoriasConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CategoriasConnection>;
};

export type CategoriasConnectionHombre = {
  __typename?: 'CategoriasConnectionHombre';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CategoriasConnection>;
};

export type CategoriasConnectionId = {
  __typename?: 'CategoriasConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CategoriasConnection>;
};

export type CategoriasConnectionMostrarEnMenu = {
  __typename?: 'CategoriasConnectionMostrarEnMenu';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CategoriasConnection>;
};

export type CategoriasConnectionMujer = {
  __typename?: 'CategoriasConnectionMujer';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CategoriasConnection>;
};

export type CategoriasConnectionNombre = {
  __typename?: 'CategoriasConnectionNombre';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoriasConnection>;
};

export type CategoriasConnectionPublished_At = {
  __typename?: 'CategoriasConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CategoriasConnection>;
};

export type CategoriasConnectionUpdated_At = {
  __typename?: 'CategoriasConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CategoriasConnection>;
};

export type CategoriasGroupBy = {
  __typename?: 'CategoriasGroupBy';
  id?: Maybe<Array<Maybe<CategoriasConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CategoriasConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CategoriasConnectionUpdated_At>>>;
  Nombre?: Maybe<Array<Maybe<CategoriasConnectionNombre>>>;
  Hombre?: Maybe<Array<Maybe<CategoriasConnectionHombre>>>;
  Mujer?: Maybe<Array<Maybe<CategoriasConnectionMujer>>>;
  CategoriaDestacada?: Maybe<Array<Maybe<CategoriasConnectionCategoriaDestacada>>>;
  MostrarEnMenu?: Maybe<Array<Maybe<CategoriasConnectionMostrarEnMenu>>>;
  published_at?: Maybe<Array<Maybe<CategoriasConnectionPublished_At>>>;
};

export type CategoriasPrincipaleInput = {
  TituloHombre?: Maybe<Scalars['String']>;
  TituloMujer?: Maybe<Scalars['String']>;
  SubtituloHombre?: Maybe<Scalars['String']>;
  SubtituloMujer?: Maybe<Scalars['String']>;
  TituloBotonHombre?: Maybe<Scalars['String']>;
  TituloBotonMujer?: Maybe<Scalars['String']>;
  ImagenHombre?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ImagenMujer?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CategoriasPrincipales = {
  __typename?: 'CategoriasPrincipales';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  TituloHombre?: Maybe<Scalars['String']>;
  TituloMujer?: Maybe<Scalars['String']>;
  SubtituloHombre?: Maybe<Scalars['String']>;
  SubtituloMujer?: Maybe<Scalars['String']>;
  TituloBotonHombre?: Maybe<Scalars['String']>;
  TituloBotonMujer?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  ImagenHombre?: Maybe<Array<Maybe<UploadFile>>>;
  ImagenMujer?: Maybe<Array<Maybe<UploadFile>>>;
};


export type CategoriasPrincipalesImagenHombreArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CategoriasPrincipalesImagenMujerArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CategoriasPrincipalesAggregator = {
  __typename?: 'CategoriasPrincipalesAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CategoriasPrincipalesConnection = {
  __typename?: 'CategoriasPrincipalesConnection';
  values?: Maybe<Array<Maybe<CategoriasPrincipales>>>;
  groupBy?: Maybe<CategoriasPrincipalesGroupBy>;
  aggregate?: Maybe<CategoriasPrincipalesAggregator>;
};

export type CategoriasPrincipalesConnectionCreated_At = {
  __typename?: 'CategoriasPrincipalesConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CategoriasPrincipalesConnection>;
};

export type CategoriasPrincipalesConnectionId = {
  __typename?: 'CategoriasPrincipalesConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CategoriasPrincipalesConnection>;
};

export type CategoriasPrincipalesConnectionPublished_At = {
  __typename?: 'CategoriasPrincipalesConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CategoriasPrincipalesConnection>;
};

export type CategoriasPrincipalesConnectionSubtituloHombre = {
  __typename?: 'CategoriasPrincipalesConnectionSubtituloHombre';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoriasPrincipalesConnection>;
};

export type CategoriasPrincipalesConnectionSubtituloMujer = {
  __typename?: 'CategoriasPrincipalesConnectionSubtituloMujer';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoriasPrincipalesConnection>;
};

export type CategoriasPrincipalesConnectionTituloBotonHombre = {
  __typename?: 'CategoriasPrincipalesConnectionTituloBotonHombre';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoriasPrincipalesConnection>;
};

export type CategoriasPrincipalesConnectionTituloBotonMujer = {
  __typename?: 'CategoriasPrincipalesConnectionTituloBotonMujer';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoriasPrincipalesConnection>;
};

export type CategoriasPrincipalesConnectionTituloHombre = {
  __typename?: 'CategoriasPrincipalesConnectionTituloHombre';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoriasPrincipalesConnection>;
};

export type CategoriasPrincipalesConnectionTituloMujer = {
  __typename?: 'CategoriasPrincipalesConnectionTituloMujer';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoriasPrincipalesConnection>;
};

export type CategoriasPrincipalesConnectionUpdated_At = {
  __typename?: 'CategoriasPrincipalesConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CategoriasPrincipalesConnection>;
};

export type CategoriasPrincipalesGroupBy = {
  __typename?: 'CategoriasPrincipalesGroupBy';
  id?: Maybe<Array<Maybe<CategoriasPrincipalesConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CategoriasPrincipalesConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CategoriasPrincipalesConnectionUpdated_At>>>;
  TituloHombre?: Maybe<Array<Maybe<CategoriasPrincipalesConnectionTituloHombre>>>;
  TituloMujer?: Maybe<Array<Maybe<CategoriasPrincipalesConnectionTituloMujer>>>;
  SubtituloHombre?: Maybe<Array<Maybe<CategoriasPrincipalesConnectionSubtituloHombre>>>;
  SubtituloMujer?: Maybe<Array<Maybe<CategoriasPrincipalesConnectionSubtituloMujer>>>;
  TituloBotonHombre?: Maybe<Array<Maybe<CategoriasPrincipalesConnectionTituloBotonHombre>>>;
  TituloBotonMujer?: Maybe<Array<Maybe<CategoriasPrincipalesConnectionTituloBotonMujer>>>;
  published_at?: Maybe<Array<Maybe<CategoriasPrincipalesConnectionPublished_At>>>;
};

export type CodigoInput = {
  Codigo?: Maybe<Scalars['String']>;
  ValorDescuento?: Maybe<Scalars['Float']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Codigos = {
  __typename?: 'Codigos';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Codigo?: Maybe<Scalars['String']>;
  ValorDescuento?: Maybe<Scalars['Float']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type CodigosAggregator = {
  __typename?: 'CodigosAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CodigosAggregatorSum>;
  avg?: Maybe<CodigosAggregatorAvg>;
  min?: Maybe<CodigosAggregatorMin>;
  max?: Maybe<CodigosAggregatorMax>;
};

export type CodigosAggregatorAvg = {
  __typename?: 'CodigosAggregatorAvg';
  ValorDescuento?: Maybe<Scalars['Float']>;
};

export type CodigosAggregatorMax = {
  __typename?: 'CodigosAggregatorMax';
  ValorDescuento?: Maybe<Scalars['Float']>;
};

export type CodigosAggregatorMin = {
  __typename?: 'CodigosAggregatorMin';
  ValorDescuento?: Maybe<Scalars['Float']>;
};

export type CodigosAggregatorSum = {
  __typename?: 'CodigosAggregatorSum';
  ValorDescuento?: Maybe<Scalars['Float']>;
};

export type CodigosConnection = {
  __typename?: 'CodigosConnection';
  values?: Maybe<Array<Maybe<Codigos>>>;
  groupBy?: Maybe<CodigosGroupBy>;
  aggregate?: Maybe<CodigosAggregator>;
};

export type CodigosConnectionCodigo = {
  __typename?: 'CodigosConnectionCodigo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CodigosConnection>;
};

export type CodigosConnectionCreated_At = {
  __typename?: 'CodigosConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CodigosConnection>;
};

export type CodigosConnectionId = {
  __typename?: 'CodigosConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CodigosConnection>;
};

export type CodigosConnectionPublished_At = {
  __typename?: 'CodigosConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CodigosConnection>;
};

export type CodigosConnectionUpdated_At = {
  __typename?: 'CodigosConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CodigosConnection>;
};

export type CodigosConnectionValorDescuento = {
  __typename?: 'CodigosConnectionValorDescuento';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CodigosConnection>;
};

export type CodigosGroupBy = {
  __typename?: 'CodigosGroupBy';
  id?: Maybe<Array<Maybe<CodigosConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CodigosConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CodigosConnectionUpdated_At>>>;
  Codigo?: Maybe<Array<Maybe<CodigosConnectionCodigo>>>;
  ValorDescuento?: Maybe<Array<Maybe<CodigosConnectionValorDescuento>>>;
  published_at?: Maybe<Array<Maybe<CodigosConnectionPublished_At>>>;
};

export type ColoreInput = {
  NombreColor?: Maybe<Scalars['String']>;
  productos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  CodigoColor?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Colores = {
  __typename?: 'Colores';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  NombreColor?: Maybe<Scalars['String']>;
  CodigoColor?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  productos?: Maybe<Array<Maybe<Productos>>>;
};


export type ColoresProductosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ColoresAggregator = {
  __typename?: 'ColoresAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ColoresConnection = {
  __typename?: 'ColoresConnection';
  values?: Maybe<Array<Maybe<Colores>>>;
  groupBy?: Maybe<ColoresGroupBy>;
  aggregate?: Maybe<ColoresAggregator>;
};

export type ColoresConnectionCodigoColor = {
  __typename?: 'ColoresConnectionCodigoColor';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ColoresConnection>;
};

export type ColoresConnectionCreated_At = {
  __typename?: 'ColoresConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ColoresConnection>;
};

export type ColoresConnectionId = {
  __typename?: 'ColoresConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ColoresConnection>;
};

export type ColoresConnectionNombreColor = {
  __typename?: 'ColoresConnectionNombreColor';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ColoresConnection>;
};

export type ColoresConnectionPublished_At = {
  __typename?: 'ColoresConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ColoresConnection>;
};

export type ColoresConnectionUpdated_At = {
  __typename?: 'ColoresConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ColoresConnection>;
};

export type ColoresGroupBy = {
  __typename?: 'ColoresGroupBy';
  id?: Maybe<Array<Maybe<ColoresConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ColoresConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ColoresConnectionUpdated_At>>>;
  NombreColor?: Maybe<Array<Maybe<ColoresConnectionNombreColor>>>;
  CodigoColor?: Maybe<Array<Maybe<ColoresConnectionCodigoColor>>>;
  published_at?: Maybe<Array<Maybe<ColoresConnectionPublished_At>>>;
};

export type Compra = {
  __typename?: 'Compra';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Nombres?: Maybe<Scalars['String']>;
  Apellidos?: Maybe<Scalars['String']>;
  NombreCalle?: Maybe<Scalars['String']>;
  NombreApartamento?: Maybe<Scalars['String']>;
  NombreCiudad?: Maybe<Scalars['String']>;
  NombreBarrio?: Maybe<Scalars['String']>;
  CodigoPostal?: Maybe<Scalars['Long']>;
  NumeroTelefono?: Maybe<Scalars['String']>;
  Correo?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  productos?: Maybe<Array<Maybe<Productos>>>;
};


export type CompraProductosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CompraAggregator = {
  __typename?: 'CompraAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CompraConnection = {
  __typename?: 'CompraConnection';
  values?: Maybe<Array<Maybe<Compra>>>;
  groupBy?: Maybe<CompraGroupBy>;
  aggregate?: Maybe<CompraAggregator>;
};

export type CompraConnectionApellidos = {
  __typename?: 'CompraConnectionApellidos';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompraConnection>;
};

export type CompraConnectionCodigoPostal = {
  __typename?: 'CompraConnectionCodigoPostal';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompraConnection>;
};

export type CompraConnectionCorreo = {
  __typename?: 'CompraConnectionCorreo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompraConnection>;
};

export type CompraConnectionCreated_At = {
  __typename?: 'CompraConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CompraConnection>;
};

export type CompraConnectionId = {
  __typename?: 'CompraConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompraConnection>;
};

export type CompraConnectionNombreApartamento = {
  __typename?: 'CompraConnectionNombreApartamento';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompraConnection>;
};

export type CompraConnectionNombreBarrio = {
  __typename?: 'CompraConnectionNombreBarrio';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompraConnection>;
};

export type CompraConnectionNombreCalle = {
  __typename?: 'CompraConnectionNombreCalle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompraConnection>;
};

export type CompraConnectionNombreCiudad = {
  __typename?: 'CompraConnectionNombreCiudad';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompraConnection>;
};

export type CompraConnectionNombres = {
  __typename?: 'CompraConnectionNombres';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompraConnection>;
};

export type CompraConnectionNumeroTelefono = {
  __typename?: 'CompraConnectionNumeroTelefono';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompraConnection>;
};

export type CompraConnectionPublished_At = {
  __typename?: 'CompraConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CompraConnection>;
};

export type CompraConnectionUpdated_At = {
  __typename?: 'CompraConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CompraConnection>;
};

export type CompraGroupBy = {
  __typename?: 'CompraGroupBy';
  id?: Maybe<Array<Maybe<CompraConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CompraConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CompraConnectionUpdated_At>>>;
  Nombres?: Maybe<Array<Maybe<CompraConnectionNombres>>>;
  Apellidos?: Maybe<Array<Maybe<CompraConnectionApellidos>>>;
  NombreCalle?: Maybe<Array<Maybe<CompraConnectionNombreCalle>>>;
  NombreApartamento?: Maybe<Array<Maybe<CompraConnectionNombreApartamento>>>;
  NombreCiudad?: Maybe<Array<Maybe<CompraConnectionNombreCiudad>>>;
  NombreBarrio?: Maybe<Array<Maybe<CompraConnectionNombreBarrio>>>;
  CodigoPostal?: Maybe<Array<Maybe<CompraConnectionCodigoPostal>>>;
  NumeroTelefono?: Maybe<Array<Maybe<CompraConnectionNumeroTelefono>>>;
  Correo?: Maybe<Array<Maybe<CompraConnectionCorreo>>>;
  published_at?: Maybe<Array<Maybe<CompraConnectionPublished_At>>>;
};

export type CompraInput = {
  Nombres?: Maybe<Scalars['String']>;
  Apellidos?: Maybe<Scalars['String']>;
  NombreCalle?: Maybe<Scalars['String']>;
  NombreApartamento?: Maybe<Scalars['String']>;
  NombreCiudad?: Maybe<Scalars['String']>;
  NombreBarrio?: Maybe<Scalars['String']>;
  CodigoPostal?: Maybe<Scalars['Long']>;
  NumeroTelefono?: Maybe<Scalars['String']>;
  Correo?: Maybe<Scalars['String']>;
  productos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};



export type EnvioInput = {
  EnvioLocal?: Maybe<Scalars['String']>;
  EnvioNacional?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Envios = {
  __typename?: 'Envios';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  EnvioLocal?: Maybe<Scalars['String']>;
  EnvioNacional?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type EnviosAggregator = {
  __typename?: 'EnviosAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EnviosConnection = {
  __typename?: 'EnviosConnection';
  values?: Maybe<Array<Maybe<Envios>>>;
  groupBy?: Maybe<EnviosGroupBy>;
  aggregate?: Maybe<EnviosAggregator>;
};

export type EnviosConnectionCreated_At = {
  __typename?: 'EnviosConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EnviosConnection>;
};

export type EnviosConnectionEnvioLocal = {
  __typename?: 'EnviosConnectionEnvioLocal';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EnviosConnection>;
};

export type EnviosConnectionEnvioNacional = {
  __typename?: 'EnviosConnectionEnvioNacional';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EnviosConnection>;
};

export type EnviosConnectionId = {
  __typename?: 'EnviosConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EnviosConnection>;
};

export type EnviosConnectionPublished_At = {
  __typename?: 'EnviosConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EnviosConnection>;
};

export type EnviosConnectionUpdated_At = {
  __typename?: 'EnviosConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EnviosConnection>;
};

export type EnviosGroupBy = {
  __typename?: 'EnviosGroupBy';
  id?: Maybe<Array<Maybe<EnviosConnectionId>>>;
  created_at?: Maybe<Array<Maybe<EnviosConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<EnviosConnectionUpdated_At>>>;
  EnvioLocal?: Maybe<Array<Maybe<EnviosConnectionEnvioLocal>>>;
  EnvioNacional?: Maybe<Array<Maybe<EnviosConnectionEnvioNacional>>>;
  published_at?: Maybe<Array<Maybe<EnviosConnectionPublished_At>>>;
};

export type Faq = {
  __typename?: 'Faq';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Pregunta?: Maybe<Scalars['String']>;
  titulo_faq?: Maybe<TituloFaq>;
  Respuesta?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type FaqAggregator = {
  __typename?: 'FaqAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type FaqConnection = {
  __typename?: 'FaqConnection';
  values?: Maybe<Array<Maybe<Faq>>>;
  groupBy?: Maybe<FaqGroupBy>;
  aggregate?: Maybe<FaqAggregator>;
};

export type FaqConnectionCreated_At = {
  __typename?: 'FaqConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FaqConnection>;
};

export type FaqConnectionId = {
  __typename?: 'FaqConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FaqConnection>;
};

export type FaqConnectionPregunta = {
  __typename?: 'FaqConnectionPregunta';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FaqConnection>;
};

export type FaqConnectionPublished_At = {
  __typename?: 'FaqConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FaqConnection>;
};

export type FaqConnectionRespuesta = {
  __typename?: 'FaqConnectionRespuesta';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FaqConnection>;
};

export type FaqConnectionTitulo_Faq = {
  __typename?: 'FaqConnectionTitulo_faq';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FaqConnection>;
};

export type FaqConnectionUpdated_At = {
  __typename?: 'FaqConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FaqConnection>;
};

export type FaqGroupBy = {
  __typename?: 'FaqGroupBy';
  id?: Maybe<Array<Maybe<FaqConnectionId>>>;
  created_at?: Maybe<Array<Maybe<FaqConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<FaqConnectionUpdated_At>>>;
  Pregunta?: Maybe<Array<Maybe<FaqConnectionPregunta>>>;
  titulo_faq?: Maybe<Array<Maybe<FaqConnectionTitulo_Faq>>>;
  Respuesta?: Maybe<Array<Maybe<FaqConnectionRespuesta>>>;
  published_at?: Maybe<Array<Maybe<FaqConnectionPublished_At>>>;
};

export type FaqInput = {
  Pregunta?: Maybe<Scalars['String']>;
  titulo_faq?: Maybe<Scalars['ID']>;
  Respuesta?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type FileInfoInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type FileInput = {
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Footer = {
  __typename?: 'Footer';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  TextoWhatsapp?: Maybe<Scalars['String']>;
  logo?: Maybe<UploadFile>;
  imagenes_metodos_de_pago?: Maybe<UploadFile>;
  Facebook?: Maybe<Scalars['String']>;
  Instagram?: Maybe<Scalars['String']>;
  LinkWhatsapp?: Maybe<Scalars['String']>;
  NumeroWhatsapp?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type FooterAggregator = {
  __typename?: 'FooterAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type FooterConnection = {
  __typename?: 'FooterConnection';
  values?: Maybe<Array<Maybe<Footer>>>;
  groupBy?: Maybe<FooterGroupBy>;
  aggregate?: Maybe<FooterAggregator>;
};

export type FooterConnectionCreated_At = {
  __typename?: 'FooterConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterConnectionFacebook = {
  __typename?: 'FooterConnectionFacebook';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterConnectionId = {
  __typename?: 'FooterConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterConnectionImagenes_Metodos_De_Pago = {
  __typename?: 'FooterConnectionImagenes_metodos_de_pago';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterConnectionInstagram = {
  __typename?: 'FooterConnectionInstagram';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterConnectionLinkWhatsapp = {
  __typename?: 'FooterConnectionLinkWhatsapp';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterConnectionLogo = {
  __typename?: 'FooterConnectionLogo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterConnectionNumeroWhatsapp = {
  __typename?: 'FooterConnectionNumeroWhatsapp';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterConnectionPublished_At = {
  __typename?: 'FooterConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterConnectionTextoWhatsapp = {
  __typename?: 'FooterConnectionTextoWhatsapp';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterConnectionUpdated_At = {
  __typename?: 'FooterConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterGroupBy = {
  __typename?: 'FooterGroupBy';
  id?: Maybe<Array<Maybe<FooterConnectionId>>>;
  created_at?: Maybe<Array<Maybe<FooterConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<FooterConnectionUpdated_At>>>;
  TextoWhatsapp?: Maybe<Array<Maybe<FooterConnectionTextoWhatsapp>>>;
  logo?: Maybe<Array<Maybe<FooterConnectionLogo>>>;
  imagenes_metodos_de_pago?: Maybe<Array<Maybe<FooterConnectionImagenes_Metodos_De_Pago>>>;
  Facebook?: Maybe<Array<Maybe<FooterConnectionFacebook>>>;
  Instagram?: Maybe<Array<Maybe<FooterConnectionInstagram>>>;
  LinkWhatsapp?: Maybe<Array<Maybe<FooterConnectionLinkWhatsapp>>>;
  NumeroWhatsapp?: Maybe<Array<Maybe<FooterConnectionNumeroWhatsapp>>>;
  published_at?: Maybe<Array<Maybe<FooterConnectionPublished_At>>>;
};

export type FooterInput = {
  TextoWhatsapp?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  imagenes_metodos_de_pago?: Maybe<Scalars['ID']>;
  Facebook?: Maybe<Scalars['String']>;
  Instagram?: Maybe<Scalars['String']>;
  LinkWhatsapp?: Maybe<Scalars['String']>;
  NumeroWhatsapp?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type GeneroCategoriaInput = {
  Imagen?: Maybe<Scalars['ID']>;
  Titulo?: Maybe<Scalars['String']>;
  TituloBoton?: Maybe<Scalars['String']>;
  LinkEscribenos?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type GeneroCategorias = {
  __typename?: 'GeneroCategorias';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Imagen?: Maybe<UploadFile>;
  Titulo?: Maybe<Scalars['String']>;
  TituloBoton?: Maybe<Scalars['String']>;
  LinkEscribenos?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type GeneroCategoriasAggregator = {
  __typename?: 'GeneroCategoriasAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GeneroCategoriasConnection = {
  __typename?: 'GeneroCategoriasConnection';
  values?: Maybe<Array<Maybe<GeneroCategorias>>>;
  groupBy?: Maybe<GeneroCategoriasGroupBy>;
  aggregate?: Maybe<GeneroCategoriasAggregator>;
};

export type GeneroCategoriasConnectionCreated_At = {
  __typename?: 'GeneroCategoriasConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<GeneroCategoriasConnection>;
};

export type GeneroCategoriasConnectionId = {
  __typename?: 'GeneroCategoriasConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<GeneroCategoriasConnection>;
};

export type GeneroCategoriasConnectionImagen = {
  __typename?: 'GeneroCategoriasConnectionImagen';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<GeneroCategoriasConnection>;
};

export type GeneroCategoriasConnectionLinkEscribenos = {
  __typename?: 'GeneroCategoriasConnectionLinkEscribenos';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<GeneroCategoriasConnection>;
};

export type GeneroCategoriasConnectionPublished_At = {
  __typename?: 'GeneroCategoriasConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<GeneroCategoriasConnection>;
};

export type GeneroCategoriasConnectionTitulo = {
  __typename?: 'GeneroCategoriasConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<GeneroCategoriasConnection>;
};

export type GeneroCategoriasConnectionTituloBoton = {
  __typename?: 'GeneroCategoriasConnectionTituloBoton';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<GeneroCategoriasConnection>;
};

export type GeneroCategoriasConnectionUpdated_At = {
  __typename?: 'GeneroCategoriasConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<GeneroCategoriasConnection>;
};

export type GeneroCategoriasGroupBy = {
  __typename?: 'GeneroCategoriasGroupBy';
  id?: Maybe<Array<Maybe<GeneroCategoriasConnectionId>>>;
  created_at?: Maybe<Array<Maybe<GeneroCategoriasConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<GeneroCategoriasConnectionUpdated_At>>>;
  Imagen?: Maybe<Array<Maybe<GeneroCategoriasConnectionImagen>>>;
  Titulo?: Maybe<Array<Maybe<GeneroCategoriasConnectionTitulo>>>;
  TituloBoton?: Maybe<Array<Maybe<GeneroCategoriasConnectionTituloBoton>>>;
  LinkEscribenos?: Maybe<Array<Maybe<GeneroCategoriasConnectionLinkEscribenos>>>;
  published_at?: Maybe<Array<Maybe<GeneroCategoriasConnectionPublished_At>>>;
};

export type Header = {
  __typename?: 'Header';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Facebook?: Maybe<Scalars['String']>;
  Instagram?: Maybe<Scalars['String']>;
  logo?: Maybe<UploadFile>;
  NumeroTelefono?: Maybe<Scalars['String']>;
  TextoDescuento?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type HeaderAggregator = {
  __typename?: 'HeaderAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type HeaderConnection = {
  __typename?: 'HeaderConnection';
  values?: Maybe<Array<Maybe<Header>>>;
  groupBy?: Maybe<HeaderGroupBy>;
  aggregate?: Maybe<HeaderAggregator>;
};

export type HeaderConnectionCreated_At = {
  __typename?: 'HeaderConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<HeaderConnection>;
};

export type HeaderConnectionFacebook = {
  __typename?: 'HeaderConnectionFacebook';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<HeaderConnection>;
};

export type HeaderConnectionId = {
  __typename?: 'HeaderConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<HeaderConnection>;
};

export type HeaderConnectionInstagram = {
  __typename?: 'HeaderConnectionInstagram';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<HeaderConnection>;
};

export type HeaderConnectionLogo = {
  __typename?: 'HeaderConnectionLogo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<HeaderConnection>;
};

export type HeaderConnectionNumeroTelefono = {
  __typename?: 'HeaderConnectionNumeroTelefono';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<HeaderConnection>;
};

export type HeaderConnectionPublished_At = {
  __typename?: 'HeaderConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<HeaderConnection>;
};

export type HeaderConnectionTextoDescuento = {
  __typename?: 'HeaderConnectionTextoDescuento';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<HeaderConnection>;
};

export type HeaderConnectionUpdated_At = {
  __typename?: 'HeaderConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<HeaderConnection>;
};

export type HeaderGroupBy = {
  __typename?: 'HeaderGroupBy';
  id?: Maybe<Array<Maybe<HeaderConnectionId>>>;
  created_at?: Maybe<Array<Maybe<HeaderConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<HeaderConnectionUpdated_At>>>;
  Facebook?: Maybe<Array<Maybe<HeaderConnectionFacebook>>>;
  Instagram?: Maybe<Array<Maybe<HeaderConnectionInstagram>>>;
  logo?: Maybe<Array<Maybe<HeaderConnectionLogo>>>;
  NumeroTelefono?: Maybe<Array<Maybe<HeaderConnectionNumeroTelefono>>>;
  TextoDescuento?: Maybe<Array<Maybe<HeaderConnectionTextoDescuento>>>;
  published_at?: Maybe<Array<Maybe<HeaderConnectionPublished_At>>>;
};

export type HeaderInput = {
  Facebook?: Maybe<Scalars['String']>;
  Instagram?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  NumeroTelefono?: Maybe<Scalars['String']>;
  TextoDescuento?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type InputId = {
  id: Scalars['ID'];
};


export type LIstaDeSuscriptoreInput = {
  Correo?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type LIstaDeSuscriptores = {
  __typename?: 'LIstaDeSuscriptores';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Correo?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type LIstaDeSuscriptoresAggregator = {
  __typename?: 'LIstaDeSuscriptoresAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type LIstaDeSuscriptoresConnection = {
  __typename?: 'LIstaDeSuscriptoresConnection';
  values?: Maybe<Array<Maybe<LIstaDeSuscriptores>>>;
  groupBy?: Maybe<LIstaDeSuscriptoresGroupBy>;
  aggregate?: Maybe<LIstaDeSuscriptoresAggregator>;
};

export type LIstaDeSuscriptoresConnectionCorreo = {
  __typename?: 'LIstaDeSuscriptoresConnectionCorreo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LIstaDeSuscriptoresConnection>;
};

export type LIstaDeSuscriptoresConnectionCreated_At = {
  __typename?: 'LIstaDeSuscriptoresConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<LIstaDeSuscriptoresConnection>;
};

export type LIstaDeSuscriptoresConnectionId = {
  __typename?: 'LIstaDeSuscriptoresConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LIstaDeSuscriptoresConnection>;
};

export type LIstaDeSuscriptoresConnectionPublished_At = {
  __typename?: 'LIstaDeSuscriptoresConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<LIstaDeSuscriptoresConnection>;
};

export type LIstaDeSuscriptoresConnectionUpdated_At = {
  __typename?: 'LIstaDeSuscriptoresConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<LIstaDeSuscriptoresConnection>;
};

export type LIstaDeSuscriptoresGroupBy = {
  __typename?: 'LIstaDeSuscriptoresGroupBy';
  id?: Maybe<Array<Maybe<LIstaDeSuscriptoresConnectionId>>>;
  created_at?: Maybe<Array<Maybe<LIstaDeSuscriptoresConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<LIstaDeSuscriptoresConnectionUpdated_At>>>;
  Correo?: Maybe<Array<Maybe<LIstaDeSuscriptoresConnectionCorreo>>>;
  published_at?: Maybe<Array<Maybe<LIstaDeSuscriptoresConnectionPublished_At>>>;
};


export type Morph = UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsLoginPayload | UserPermissionsPasswordPayload | CategoriasPrincipales | CategoriasPrincipalesConnection | CategoriasPrincipalesAggregator | CategoriasPrincipalesGroupBy | CategoriasPrincipalesConnectionId | CategoriasPrincipalesConnectionCreated_At | CategoriasPrincipalesConnectionUpdated_At | CategoriasPrincipalesConnectionTituloHombre | CategoriasPrincipalesConnectionTituloMujer | CategoriasPrincipalesConnectionSubtituloHombre | CategoriasPrincipalesConnectionSubtituloMujer | CategoriasPrincipalesConnectionTituloBotonHombre | CategoriasPrincipalesConnectionTituloBotonMujer | CategoriasPrincipalesConnectionPublished_At | CreateCategoriasPrincipalePayload | UpdateCategoriasPrincipalePayload | DeleteCategoriasPrincipalePayload | Categorias | CategoriasConnection | CategoriasAggregator | CategoriasGroupBy | CategoriasConnectionId | CategoriasConnectionCreated_At | CategoriasConnectionUpdated_At | CategoriasConnectionNombre | CategoriasConnectionHombre | CategoriasConnectionMujer | CategoriasConnectionCategoriaDestacada | CategoriasConnectionMostrarEnMenu | CategoriasConnectionPublished_At | CreateCategoriaPayload | UpdateCategoriaPayload | DeleteCategoriaPayload | Codigos | CodigosConnection | CodigosAggregator | CodigosAggregatorSum | CodigosAggregatorAvg | CodigosAggregatorMin | CodigosAggregatorMax | CodigosGroupBy | CodigosConnectionId | CodigosConnectionCreated_At | CodigosConnectionUpdated_At | CodigosConnectionCodigo | CodigosConnectionValorDescuento | CodigosConnectionPublished_At | CreateCodigoPayload | UpdateCodigoPayload | DeleteCodigoPayload | Colores | ColoresConnection | ColoresAggregator | ColoresGroupBy | ColoresConnectionId | ColoresConnectionCreated_At | ColoresConnectionUpdated_At | ColoresConnectionNombreColor | ColoresConnectionCodigoColor | ColoresConnectionPublished_At | CreateColorePayload | UpdateColorePayload | DeleteColorePayload | Compra | CompraConnection | CompraAggregator | CompraGroupBy | CompraConnectionId | CompraConnectionCreated_At | CompraConnectionUpdated_At | CompraConnectionNombres | CompraConnectionApellidos | CompraConnectionNombreCalle | CompraConnectionNombreApartamento | CompraConnectionNombreCiudad | CompraConnectionNombreBarrio | CompraConnectionCodigoPostal | CompraConnectionNumeroTelefono | CompraConnectionCorreo | CompraConnectionPublished_At | CreateCompraPayload | UpdateCompraPayload | DeleteCompraPayload | Envios | EnviosConnection | EnviosAggregator | EnviosGroupBy | EnviosConnectionId | EnviosConnectionCreated_At | EnviosConnectionUpdated_At | EnviosConnectionEnvioLocal | EnviosConnectionEnvioNacional | EnviosConnectionPublished_At | CreateEnvioPayload | UpdateEnvioPayload | DeleteEnvioPayload | Faq | FaqConnection | FaqAggregator | FaqGroupBy | FaqConnectionId | FaqConnectionCreated_At | FaqConnectionUpdated_At | FaqConnectionPregunta | FaqConnectionTitulo_Faq | FaqConnectionRespuesta | FaqConnectionPublished_At | CreateFaqPayload | UpdateFaqPayload | DeleteFaqPayload | Footer | FooterConnection | FooterAggregator | FooterGroupBy | FooterConnectionId | FooterConnectionCreated_At | FooterConnectionUpdated_At | FooterConnectionTextoWhatsapp | FooterConnectionLogo | FooterConnectionImagenes_Metodos_De_Pago | FooterConnectionFacebook | FooterConnectionInstagram | FooterConnectionLinkWhatsapp | FooterConnectionNumeroWhatsapp | FooterConnectionPublished_At | CreateFooterPayload | UpdateFooterPayload | DeleteFooterPayload | GeneroCategorias | GeneroCategoriasConnection | GeneroCategoriasAggregator | GeneroCategoriasGroupBy | GeneroCategoriasConnectionId | GeneroCategoriasConnectionCreated_At | GeneroCategoriasConnectionUpdated_At | GeneroCategoriasConnectionImagen | GeneroCategoriasConnectionTitulo | GeneroCategoriasConnectionTituloBoton | GeneroCategoriasConnectionLinkEscribenos | GeneroCategoriasConnectionPublished_At | CreateGeneroCategoriaPayload | UpdateGeneroCategoriaPayload | DeleteGeneroCategoriaPayload | Header | HeaderConnection | HeaderAggregator | HeaderGroupBy | HeaderConnectionId | HeaderConnectionCreated_At | HeaderConnectionUpdated_At | HeaderConnectionFacebook | HeaderConnectionInstagram | HeaderConnectionLogo | HeaderConnectionNumeroTelefono | HeaderConnectionTextoDescuento | HeaderConnectionPublished_At | CreateHeaderPayload | UpdateHeaderPayload | DeleteHeaderPayload | LIstaDeSuscriptores | LIstaDeSuscriptoresConnection | LIstaDeSuscriptoresAggregator | LIstaDeSuscriptoresGroupBy | LIstaDeSuscriptoresConnectionId | LIstaDeSuscriptoresConnectionCreated_At | LIstaDeSuscriptoresConnectionUpdated_At | LIstaDeSuscriptoresConnectionCorreo | LIstaDeSuscriptoresConnectionPublished_At | CreateLIstaDeSuscriptorePayload | UpdateLIstaDeSuscriptorePayload | DeleteLIstaDeSuscriptorePayload | PaginaDeContacto | PaginaDeContactoConnection | PaginaDeContactoAggregator | PaginaDeContactoGroupBy | PaginaDeContactoConnectionId | PaginaDeContactoConnectionCreated_At | PaginaDeContactoConnectionUpdated_At | PaginaDeContactoConnectionImagen | PaginaDeContactoConnectionTitulo_Oficina | PaginaDeContactoConnectionTexto_Oficina | PaginaDeContactoConnectionTitulo_Informacion_Contacto | PaginaDeContactoConnectionTexto_Informacion_Contacto | PaginaDeContactoConnectionTitulo_Redes | PaginaDeContactoConnectionFacebook | PaginaDeContactoConnectionInstagram | PaginaDeContactoConnectionTitulo_Imagen | PaginaDeContactoConnectionPublished_At | CreatePaginaDeContactoPayload | UpdatePaginaDeContactoPayload | DeletePaginaDeContactoPayload | PaginaSomos | PaginaSomosConnection | PaginaSomosAggregator | PaginaSomosGroupBy | PaginaSomosConnectionId | PaginaSomosConnectionCreated_At | PaginaSomosConnectionUpdated_At | PaginaSomosConnectionSubtituloImagen | PaginaSomosConnectionTextoVision | PaginaSomosConnectionTextoMision | PaginaSomosConnectionTituloImagen | PaginaSomosConnectionTextoPrincipal | PaginaSomosConnectionPublished_At | CreatePaginaSomoPayload | UpdatePaginaSomoPayload | DeletePaginaSomoPayload | Productos | ProductosConnection | ProductosAggregator | ProductosGroupBy | ProductosConnectionId | ProductosConnectionCreated_At | ProductosConnectionUpdated_At | ProductosConnectionTitulo | ProductosConnectionDescripcion | ProductosConnectionSku | ProductosConnectionNuevo | ProductosConnectionDescuento | ProductosConnectionPrecio | ProductosConnectionCategoria | ProductosConnectionSalePrice | ProductosConnectionDestacado | ProductosConnectionPublished_At | CreateProductoPayload | UpdateProductoPayload | DeleteProductoPayload | Prueba | PruebaConnection | PruebaAggregator | PruebaGroupBy | PruebaConnectionId | PruebaConnectionCreated_At | PruebaConnectionUpdated_At | PruebaConnectionTextoBoton | PruebaConnectionUrlBoton | PruebaConnectionPublished_At | CreatePruebaPayload | UpdatePruebaPayload | DeletePruebaPayload | TituloFaq | TituloFaqConnection | TituloFaqAggregator | TituloFaqGroupBy | TituloFaqConnectionId | TituloFaqConnectionCreated_At | TituloFaqConnectionUpdated_At | TituloFaqConnectionNombre | TituloFaqConnectionPublished_At | CreateTituloFaqPayload | UpdateTituloFaqPayload | DeleteTituloFaqPayload | VentanasEmergente | VentanasEmergenteConnection | VentanasEmergenteAggregator | VentanasEmergenteGroupBy | VentanasEmergenteConnectionId | VentanasEmergenteConnectionCreated_At | VentanasEmergenteConnectionUpdated_At | VentanasEmergenteConnectionTitulo | VentanasEmergenteConnectionTexto | VentanasEmergenteConnectionTextoBoton | VentanasEmergenteConnectionHabilitado | VentanasEmergenteConnectionPorcentajeDescuento | VentanasEmergenteConnectionLogo | VentanasEmergenteConnectionPublished_At | CreateVentanasEmergentePayload | UpdateVentanasEmergentePayload | DeleteVentanasEmergentePayload | UploadFile | UploadFileConnection | UploadFileAggregator | UploadFileAggregatorSum | UploadFileAggregatorAvg | UploadFileAggregatorMin | UploadFileAggregatorMax | UploadFileGroupBy | UploadFileConnectionId | UploadFileConnectionCreated_At | UploadFileConnectionUpdated_At | UploadFileConnectionName | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionWidth | UploadFileConnectionHeight | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionExt | UploadFileConnectionMime | UploadFileConnectionSize | UploadFileConnectionUrl | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | DeleteFilePayload | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleConnection | UsersPermissionsRoleAggregator | UsersPermissionsRoleGroupBy | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionType | CreateRolePayload | UpdateRolePayload | DeleteRolePayload | UsersPermissionsUser | UsersPermissionsUserConnection | UsersPermissionsUserAggregator | UsersPermissionsUserGroupBy | UsersPermissionsUserConnectionId | UsersPermissionsUserConnectionCreated_At | UsersPermissionsUserConnectionUpdated_At | UsersPermissionsUserConnectionUsername | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionRole | CreateUserPayload | UpdateUserPayload | DeleteUserPayload;

export type Mutation = {
  __typename?: 'Mutation';
  createCategoriasPrincipale?: Maybe<CreateCategoriasPrincipalePayload>;
  updateCategoriasPrincipale?: Maybe<UpdateCategoriasPrincipalePayload>;
  deleteCategoriasPrincipale?: Maybe<DeleteCategoriasPrincipalePayload>;
  createCategoria?: Maybe<CreateCategoriaPayload>;
  updateCategoria?: Maybe<UpdateCategoriaPayload>;
  deleteCategoria?: Maybe<DeleteCategoriaPayload>;
  createCodigo?: Maybe<CreateCodigoPayload>;
  updateCodigo?: Maybe<UpdateCodigoPayload>;
  deleteCodigo?: Maybe<DeleteCodigoPayload>;
  createColore?: Maybe<CreateColorePayload>;
  updateColore?: Maybe<UpdateColorePayload>;
  deleteColore?: Maybe<DeleteColorePayload>;
  createCompra?: Maybe<CreateCompraPayload>;
  updateCompra?: Maybe<UpdateCompraPayload>;
  deleteCompra?: Maybe<DeleteCompraPayload>;
  createEnvio?: Maybe<CreateEnvioPayload>;
  updateEnvio?: Maybe<UpdateEnvioPayload>;
  deleteEnvio?: Maybe<DeleteEnvioPayload>;
  createFaq?: Maybe<CreateFaqPayload>;
  updateFaq?: Maybe<UpdateFaqPayload>;
  deleteFaq?: Maybe<DeleteFaqPayload>;
  createFooter?: Maybe<CreateFooterPayload>;
  updateFooter?: Maybe<UpdateFooterPayload>;
  deleteFooter?: Maybe<DeleteFooterPayload>;
  createGeneroCategoria?: Maybe<CreateGeneroCategoriaPayload>;
  updateGeneroCategoria?: Maybe<UpdateGeneroCategoriaPayload>;
  deleteGeneroCategoria?: Maybe<DeleteGeneroCategoriaPayload>;
  createHeader?: Maybe<CreateHeaderPayload>;
  updateHeader?: Maybe<UpdateHeaderPayload>;
  deleteHeader?: Maybe<DeleteHeaderPayload>;
  createLIstaDeSuscriptore?: Maybe<CreateLIstaDeSuscriptorePayload>;
  updateLIstaDeSuscriptore?: Maybe<UpdateLIstaDeSuscriptorePayload>;
  deleteLIstaDeSuscriptore?: Maybe<DeleteLIstaDeSuscriptorePayload>;
  createPaginaDeContacto?: Maybe<CreatePaginaDeContactoPayload>;
  updatePaginaDeContacto?: Maybe<UpdatePaginaDeContactoPayload>;
  deletePaginaDeContacto?: Maybe<DeletePaginaDeContactoPayload>;
  createPaginaSomo?: Maybe<CreatePaginaSomoPayload>;
  updatePaginaSomo?: Maybe<UpdatePaginaSomoPayload>;
  deletePaginaSomo?: Maybe<DeletePaginaSomoPayload>;
  createProducto?: Maybe<CreateProductoPayload>;
  updateProducto?: Maybe<UpdateProductoPayload>;
  deleteProducto?: Maybe<DeleteProductoPayload>;
  createPrueba?: Maybe<CreatePruebaPayload>;
  updatePrueba?: Maybe<UpdatePruebaPayload>;
  deletePrueba?: Maybe<DeletePruebaPayload>;
  createTituloFaq?: Maybe<CreateTituloFaqPayload>;
  updateTituloFaq?: Maybe<UpdateTituloFaqPayload>;
  deleteTituloFaq?: Maybe<DeleteTituloFaqPayload>;
  createVentanasEmergente?: Maybe<CreateVentanasEmergentePayload>;
  updateVentanasEmergente?: Maybe<UpdateVentanasEmergentePayload>;
  deleteVentanasEmergente?: Maybe<DeleteVentanasEmergentePayload>;
  /** Delete one file */
  deleteFile?: Maybe<DeleteFilePayload>;
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>;
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>;
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>;
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>;
  upload: UploadFile;
  multipleUpload: Array<Maybe<UploadFile>>;
  updateFileInfo: UploadFile;
  login: UsersPermissionsLoginPayload;
  register: UsersPermissionsLoginPayload;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
};


export type MutationCreateCategoriasPrincipaleArgs = {
  input?: Maybe<CreateCategoriasPrincipaleInput>;
};


export type MutationUpdateCategoriasPrincipaleArgs = {
  input?: Maybe<UpdateCategoriasPrincipaleInput>;
};


export type MutationDeleteCategoriasPrincipaleArgs = {
  input?: Maybe<DeleteCategoriasPrincipaleInput>;
};


export type MutationCreateCategoriaArgs = {
  input?: Maybe<CreateCategoriaInput>;
};


export type MutationUpdateCategoriaArgs = {
  input?: Maybe<UpdateCategoriaInput>;
};


export type MutationDeleteCategoriaArgs = {
  input?: Maybe<DeleteCategoriaInput>;
};


export type MutationCreateCodigoArgs = {
  input?: Maybe<CreateCodigoInput>;
};


export type MutationUpdateCodigoArgs = {
  input?: Maybe<UpdateCodigoInput>;
};


export type MutationDeleteCodigoArgs = {
  input?: Maybe<DeleteCodigoInput>;
};


export type MutationCreateColoreArgs = {
  input?: Maybe<CreateColoreInput>;
};


export type MutationUpdateColoreArgs = {
  input?: Maybe<UpdateColoreInput>;
};


export type MutationDeleteColoreArgs = {
  input?: Maybe<DeleteColoreInput>;
};


export type MutationCreateCompraArgs = {
  input?: Maybe<CreateCompraInput>;
};


export type MutationUpdateCompraArgs = {
  input?: Maybe<UpdateCompraInput>;
};


export type MutationDeleteCompraArgs = {
  input?: Maybe<DeleteCompraInput>;
};


export type MutationCreateEnvioArgs = {
  input?: Maybe<CreateEnvioInput>;
};


export type MutationUpdateEnvioArgs = {
  input?: Maybe<UpdateEnvioInput>;
};


export type MutationDeleteEnvioArgs = {
  input?: Maybe<DeleteEnvioInput>;
};


export type MutationCreateFaqArgs = {
  input?: Maybe<CreateFaqInput>;
};


export type MutationUpdateFaqArgs = {
  input?: Maybe<UpdateFaqInput>;
};


export type MutationDeleteFaqArgs = {
  input?: Maybe<DeleteFaqInput>;
};


export type MutationCreateFooterArgs = {
  input?: Maybe<CreateFooterInput>;
};


export type MutationUpdateFooterArgs = {
  input?: Maybe<UpdateFooterInput>;
};


export type MutationDeleteFooterArgs = {
  input?: Maybe<DeleteFooterInput>;
};


export type MutationCreateGeneroCategoriaArgs = {
  input?: Maybe<CreateGeneroCategoriaInput>;
};


export type MutationUpdateGeneroCategoriaArgs = {
  input?: Maybe<UpdateGeneroCategoriaInput>;
};


export type MutationDeleteGeneroCategoriaArgs = {
  input?: Maybe<DeleteGeneroCategoriaInput>;
};


export type MutationCreateHeaderArgs = {
  input?: Maybe<CreateHeaderInput>;
};


export type MutationUpdateHeaderArgs = {
  input?: Maybe<UpdateHeaderInput>;
};


export type MutationDeleteHeaderArgs = {
  input?: Maybe<DeleteHeaderInput>;
};


export type MutationCreateLIstaDeSuscriptoreArgs = {
  input?: Maybe<CreateLIstaDeSuscriptoreInput>;
};


export type MutationUpdateLIstaDeSuscriptoreArgs = {
  input?: Maybe<UpdateLIstaDeSuscriptoreInput>;
};


export type MutationDeleteLIstaDeSuscriptoreArgs = {
  input?: Maybe<DeleteLIstaDeSuscriptoreInput>;
};


export type MutationCreatePaginaDeContactoArgs = {
  input?: Maybe<CreatePaginaDeContactoInput>;
};


export type MutationUpdatePaginaDeContactoArgs = {
  input?: Maybe<UpdatePaginaDeContactoInput>;
};


export type MutationDeletePaginaDeContactoArgs = {
  input?: Maybe<DeletePaginaDeContactoInput>;
};


export type MutationCreatePaginaSomoArgs = {
  input?: Maybe<CreatePaginaSomoInput>;
};


export type MutationUpdatePaginaSomoArgs = {
  input?: Maybe<UpdatePaginaSomoInput>;
};


export type MutationDeletePaginaSomoArgs = {
  input?: Maybe<DeletePaginaSomoInput>;
};


export type MutationCreateProductoArgs = {
  input?: Maybe<CreateProductoInput>;
};


export type MutationUpdateProductoArgs = {
  input?: Maybe<UpdateProductoInput>;
};


export type MutationDeleteProductoArgs = {
  input?: Maybe<DeleteProductoInput>;
};


export type MutationCreatePruebaArgs = {
  input?: Maybe<CreatePruebaInput>;
};


export type MutationUpdatePruebaArgs = {
  input?: Maybe<UpdatePruebaInput>;
};


export type MutationDeletePruebaArgs = {
  input?: Maybe<DeletePruebaInput>;
};


export type MutationCreateTituloFaqArgs = {
  input?: Maybe<CreateTituloFaqInput>;
};


export type MutationUpdateTituloFaqArgs = {
  input?: Maybe<UpdateTituloFaqInput>;
};


export type MutationDeleteTituloFaqArgs = {
  input?: Maybe<DeleteTituloFaqInput>;
};


export type MutationCreateVentanasEmergenteArgs = {
  input?: Maybe<CreateVentanasEmergenteInput>;
};


export type MutationUpdateVentanasEmergenteArgs = {
  input?: Maybe<UpdateVentanasEmergenteInput>;
};


export type MutationDeleteVentanasEmergenteArgs = {
  input?: Maybe<DeleteVentanasEmergenteInput>;
};


export type MutationDeleteFileArgs = {
  input?: Maybe<DeleteFileInput>;
};


export type MutationCreateRoleArgs = {
  input?: Maybe<CreateRoleInput>;
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>;
};


export type MutationDeleteRoleArgs = {
  input?: Maybe<DeleteRoleInput>;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationDeleteUserArgs = {
  input?: Maybe<DeleteUserInput>;
};


export type MutationUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  info?: Maybe<FileInfoInput>;
  file: Scalars['Upload'];
};


export type MutationMultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info: FileInfoInput;
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};

export type PaginaDeContacto = {
  __typename?: 'PaginaDeContacto';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Imagen?: Maybe<UploadFile>;
  Titulo_oficina?: Maybe<Scalars['String']>;
  Texto_oficina?: Maybe<Scalars['String']>;
  titulo_informacion_contacto?: Maybe<Scalars['String']>;
  texto_informacion_contacto?: Maybe<Scalars['String']>;
  titulo_redes?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  Titulo_imagen?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type PaginaDeContactoAggregator = {
  __typename?: 'PaginaDeContactoAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginaDeContactoConnection = {
  __typename?: 'PaginaDeContactoConnection';
  values?: Maybe<Array<Maybe<PaginaDeContacto>>>;
  groupBy?: Maybe<PaginaDeContactoGroupBy>;
  aggregate?: Maybe<PaginaDeContactoAggregator>;
};

export type PaginaDeContactoConnectionCreated_At = {
  __typename?: 'PaginaDeContactoConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PaginaDeContactoConnection>;
};

export type PaginaDeContactoConnectionFacebook = {
  __typename?: 'PaginaDeContactoConnectionFacebook';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaginaDeContactoConnection>;
};

export type PaginaDeContactoConnectionId = {
  __typename?: 'PaginaDeContactoConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaginaDeContactoConnection>;
};

export type PaginaDeContactoConnectionImagen = {
  __typename?: 'PaginaDeContactoConnectionImagen';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaginaDeContactoConnection>;
};

export type PaginaDeContactoConnectionInstagram = {
  __typename?: 'PaginaDeContactoConnectionInstagram';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaginaDeContactoConnection>;
};

export type PaginaDeContactoConnectionPublished_At = {
  __typename?: 'PaginaDeContactoConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PaginaDeContactoConnection>;
};

export type PaginaDeContactoConnectionTexto_Informacion_Contacto = {
  __typename?: 'PaginaDeContactoConnectionTexto_informacion_contacto';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaginaDeContactoConnection>;
};

export type PaginaDeContactoConnectionTexto_Oficina = {
  __typename?: 'PaginaDeContactoConnectionTexto_oficina';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaginaDeContactoConnection>;
};

export type PaginaDeContactoConnectionTitulo_Imagen = {
  __typename?: 'PaginaDeContactoConnectionTitulo_imagen';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaginaDeContactoConnection>;
};

export type PaginaDeContactoConnectionTitulo_Informacion_Contacto = {
  __typename?: 'PaginaDeContactoConnectionTitulo_informacion_contacto';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaginaDeContactoConnection>;
};

export type PaginaDeContactoConnectionTitulo_Oficina = {
  __typename?: 'PaginaDeContactoConnectionTitulo_oficina';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaginaDeContactoConnection>;
};

export type PaginaDeContactoConnectionTitulo_Redes = {
  __typename?: 'PaginaDeContactoConnectionTitulo_redes';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaginaDeContactoConnection>;
};

export type PaginaDeContactoConnectionUpdated_At = {
  __typename?: 'PaginaDeContactoConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PaginaDeContactoConnection>;
};

export type PaginaDeContactoGroupBy = {
  __typename?: 'PaginaDeContactoGroupBy';
  id?: Maybe<Array<Maybe<PaginaDeContactoConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PaginaDeContactoConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PaginaDeContactoConnectionUpdated_At>>>;
  Imagen?: Maybe<Array<Maybe<PaginaDeContactoConnectionImagen>>>;
  Titulo_oficina?: Maybe<Array<Maybe<PaginaDeContactoConnectionTitulo_Oficina>>>;
  Texto_oficina?: Maybe<Array<Maybe<PaginaDeContactoConnectionTexto_Oficina>>>;
  titulo_informacion_contacto?: Maybe<Array<Maybe<PaginaDeContactoConnectionTitulo_Informacion_Contacto>>>;
  texto_informacion_contacto?: Maybe<Array<Maybe<PaginaDeContactoConnectionTexto_Informacion_Contacto>>>;
  titulo_redes?: Maybe<Array<Maybe<PaginaDeContactoConnectionTitulo_Redes>>>;
  facebook?: Maybe<Array<Maybe<PaginaDeContactoConnectionFacebook>>>;
  instagram?: Maybe<Array<Maybe<PaginaDeContactoConnectionInstagram>>>;
  Titulo_imagen?: Maybe<Array<Maybe<PaginaDeContactoConnectionTitulo_Imagen>>>;
  published_at?: Maybe<Array<Maybe<PaginaDeContactoConnectionPublished_At>>>;
};

export type PaginaDeContactoInput = {
  Imagen?: Maybe<Scalars['ID']>;
  Titulo_oficina?: Maybe<Scalars['String']>;
  Texto_oficina?: Maybe<Scalars['String']>;
  titulo_informacion_contacto?: Maybe<Scalars['String']>;
  texto_informacion_contacto?: Maybe<Scalars['String']>;
  titulo_redes?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  Titulo_imagen?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type PaginaSomoInput = {
  BannerImagen?: Maybe<Array<Maybe<Scalars['ID']>>>;
  SubtituloImagen?: Maybe<Scalars['String']>;
  TextoVision?: Maybe<Scalars['String']>;
  TextoMision?: Maybe<Scalars['String']>;
  TituloImagen?: Maybe<Scalars['String']>;
  TextoPrincipal?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type PaginaSomos = {
  __typename?: 'PaginaSomos';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  SubtituloImagen?: Maybe<Scalars['String']>;
  TextoVision?: Maybe<Scalars['String']>;
  TextoMision?: Maybe<Scalars['String']>;
  TituloImagen?: Maybe<Scalars['String']>;
  TextoPrincipal?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  BannerImagen?: Maybe<Array<Maybe<UploadFile>>>;
};


export type PaginaSomosBannerImagenArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type PaginaSomosAggregator = {
  __typename?: 'PaginaSomosAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginaSomosConnection = {
  __typename?: 'PaginaSomosConnection';
  values?: Maybe<Array<Maybe<PaginaSomos>>>;
  groupBy?: Maybe<PaginaSomosGroupBy>;
  aggregate?: Maybe<PaginaSomosAggregator>;
};

export type PaginaSomosConnectionCreated_At = {
  __typename?: 'PaginaSomosConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PaginaSomosConnection>;
};

export type PaginaSomosConnectionId = {
  __typename?: 'PaginaSomosConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaginaSomosConnection>;
};

export type PaginaSomosConnectionPublished_At = {
  __typename?: 'PaginaSomosConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PaginaSomosConnection>;
};

export type PaginaSomosConnectionSubtituloImagen = {
  __typename?: 'PaginaSomosConnectionSubtituloImagen';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaginaSomosConnection>;
};

export type PaginaSomosConnectionTextoMision = {
  __typename?: 'PaginaSomosConnectionTextoMision';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaginaSomosConnection>;
};

export type PaginaSomosConnectionTextoPrincipal = {
  __typename?: 'PaginaSomosConnectionTextoPrincipal';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaginaSomosConnection>;
};

export type PaginaSomosConnectionTextoVision = {
  __typename?: 'PaginaSomosConnectionTextoVision';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaginaSomosConnection>;
};

export type PaginaSomosConnectionTituloImagen = {
  __typename?: 'PaginaSomosConnectionTituloImagen';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaginaSomosConnection>;
};

export type PaginaSomosConnectionUpdated_At = {
  __typename?: 'PaginaSomosConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PaginaSomosConnection>;
};

export type PaginaSomosGroupBy = {
  __typename?: 'PaginaSomosGroupBy';
  id?: Maybe<Array<Maybe<PaginaSomosConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PaginaSomosConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PaginaSomosConnectionUpdated_At>>>;
  SubtituloImagen?: Maybe<Array<Maybe<PaginaSomosConnectionSubtituloImagen>>>;
  TextoVision?: Maybe<Array<Maybe<PaginaSomosConnectionTextoVision>>>;
  TextoMision?: Maybe<Array<Maybe<PaginaSomosConnectionTextoMision>>>;
  TituloImagen?: Maybe<Array<Maybe<PaginaSomosConnectionTituloImagen>>>;
  TextoPrincipal?: Maybe<Array<Maybe<PaginaSomosConnectionTextoPrincipal>>>;
  published_at?: Maybe<Array<Maybe<PaginaSomosConnectionPublished_At>>>;
};

export type ProductoInput = {
  Titulo?: Maybe<Scalars['String']>;
  Descripcion?: Maybe<Scalars['String']>;
  SKU?: Maybe<Scalars['String']>;
  Imagenes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Nuevo?: Maybe<Scalars['Boolean']>;
  Descuento?: Maybe<Scalars['Boolean']>;
  precio?: Maybe<Scalars['Long']>;
  categoria?: Maybe<Scalars['ID']>;
  salePrice?: Maybe<Scalars['Long']>;
  Destacado?: Maybe<Scalars['Boolean']>;
  colores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Productos = {
  __typename?: 'Productos';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Titulo?: Maybe<Scalars['String']>;
  Descripcion?: Maybe<Scalars['String']>;
  SKU?: Maybe<Scalars['String']>;
  Nuevo?: Maybe<Scalars['Boolean']>;
  Descuento?: Maybe<Scalars['Boolean']>;
  precio?: Maybe<Scalars['Long']>;
  categoria?: Maybe<Categorias>;
  salePrice?: Maybe<Scalars['Long']>;
  Destacado?: Maybe<Scalars['Boolean']>;
  published_at?: Maybe<Scalars['DateTime']>;
  Imagenes?: Maybe<Array<Maybe<UploadFile>>>;
  colores?: Maybe<Array<Maybe<Colores>>>;
};


export type ProductosImagenesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProductosColoresArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ProductosAggregator = {
  __typename?: 'ProductosAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProductosConnection = {
  __typename?: 'ProductosConnection';
  values?: Maybe<Array<Maybe<Productos>>>;
  groupBy?: Maybe<ProductosGroupBy>;
  aggregate?: Maybe<ProductosAggregator>;
};

export type ProductosConnectionCategoria = {
  __typename?: 'ProductosConnectionCategoria';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductosConnection>;
};

export type ProductosConnectionCreated_At = {
  __typename?: 'ProductosConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProductosConnection>;
};

export type ProductosConnectionDescripcion = {
  __typename?: 'ProductosConnectionDescripcion';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductosConnection>;
};

export type ProductosConnectionDescuento = {
  __typename?: 'ProductosConnectionDescuento';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProductosConnection>;
};

export type ProductosConnectionDestacado = {
  __typename?: 'ProductosConnectionDestacado';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProductosConnection>;
};

export type ProductosConnectionId = {
  __typename?: 'ProductosConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductosConnection>;
};

export type ProductosConnectionNuevo = {
  __typename?: 'ProductosConnectionNuevo';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProductosConnection>;
};

export type ProductosConnectionPrecio = {
  __typename?: 'ProductosConnectionPrecio';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductosConnection>;
};

export type ProductosConnectionPublished_At = {
  __typename?: 'ProductosConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProductosConnection>;
};

export type ProductosConnectionSku = {
  __typename?: 'ProductosConnectionSKU';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductosConnection>;
};

export type ProductosConnectionSalePrice = {
  __typename?: 'ProductosConnectionSalePrice';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductosConnection>;
};

export type ProductosConnectionTitulo = {
  __typename?: 'ProductosConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductosConnection>;
};

export type ProductosConnectionUpdated_At = {
  __typename?: 'ProductosConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProductosConnection>;
};

export type ProductosGroupBy = {
  __typename?: 'ProductosGroupBy';
  id?: Maybe<Array<Maybe<ProductosConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ProductosConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ProductosConnectionUpdated_At>>>;
  Titulo?: Maybe<Array<Maybe<ProductosConnectionTitulo>>>;
  Descripcion?: Maybe<Array<Maybe<ProductosConnectionDescripcion>>>;
  SKU?: Maybe<Array<Maybe<ProductosConnectionSku>>>;
  Nuevo?: Maybe<Array<Maybe<ProductosConnectionNuevo>>>;
  Descuento?: Maybe<Array<Maybe<ProductosConnectionDescuento>>>;
  precio?: Maybe<Array<Maybe<ProductosConnectionPrecio>>>;
  categoria?: Maybe<Array<Maybe<ProductosConnectionCategoria>>>;
  salePrice?: Maybe<Array<Maybe<ProductosConnectionSalePrice>>>;
  Destacado?: Maybe<Array<Maybe<ProductosConnectionDestacado>>>;
  published_at?: Maybe<Array<Maybe<ProductosConnectionPublished_At>>>;
};

export type Prueba = {
  __typename?: 'Prueba';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  TextoBoton?: Maybe<Scalars['String']>;
  UrlBoton?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  Imagen_1?: Maybe<Array<Maybe<UploadFile>>>;
};


export type PruebaImagen_1Args = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type PruebaAggregator = {
  __typename?: 'PruebaAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PruebaConnection = {
  __typename?: 'PruebaConnection';
  values?: Maybe<Array<Maybe<Prueba>>>;
  groupBy?: Maybe<PruebaGroupBy>;
  aggregate?: Maybe<PruebaAggregator>;
};

export type PruebaConnectionCreated_At = {
  __typename?: 'PruebaConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PruebaConnection>;
};

export type PruebaConnectionId = {
  __typename?: 'PruebaConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PruebaConnection>;
};

export type PruebaConnectionPublished_At = {
  __typename?: 'PruebaConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PruebaConnection>;
};

export type PruebaConnectionTextoBoton = {
  __typename?: 'PruebaConnectionTextoBoton';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PruebaConnection>;
};

export type PruebaConnectionUpdated_At = {
  __typename?: 'PruebaConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PruebaConnection>;
};

export type PruebaConnectionUrlBoton = {
  __typename?: 'PruebaConnectionUrlBoton';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PruebaConnection>;
};

export type PruebaGroupBy = {
  __typename?: 'PruebaGroupBy';
  id?: Maybe<Array<Maybe<PruebaConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PruebaConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PruebaConnectionUpdated_At>>>;
  TextoBoton?: Maybe<Array<Maybe<PruebaConnectionTextoBoton>>>;
  UrlBoton?: Maybe<Array<Maybe<PruebaConnectionUrlBoton>>>;
  published_at?: Maybe<Array<Maybe<PruebaConnectionPublished_At>>>;
};

export type PruebaInput = {
  TextoBoton?: Maybe<Scalars['String']>;
  Imagen_1?: Maybe<Array<Maybe<Scalars['ID']>>>;
  UrlBoton?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  categoriasPrincipale?: Maybe<CategoriasPrincipales>;
  categoriasPrincipales?: Maybe<Array<Maybe<CategoriasPrincipales>>>;
  categoriasPrincipalesConnection?: Maybe<CategoriasPrincipalesConnection>;
  categoria?: Maybe<Categorias>;
  categorias?: Maybe<Array<Maybe<Categorias>>>;
  categoriasConnection?: Maybe<CategoriasConnection>;
  codigo?: Maybe<Codigos>;
  codigos?: Maybe<Array<Maybe<Codigos>>>;
  codigosConnection?: Maybe<CodigosConnection>;
  colore?: Maybe<Colores>;
  colores?: Maybe<Array<Maybe<Colores>>>;
  coloresConnection?: Maybe<ColoresConnection>;
  compra?: Maybe<Compra>;
  compras?: Maybe<Array<Maybe<Compra>>>;
  comprasConnection?: Maybe<CompraConnection>;
  envio?: Maybe<Envios>;
  envios?: Maybe<Array<Maybe<Envios>>>;
  enviosConnection?: Maybe<EnviosConnection>;
  faq?: Maybe<Faq>;
  faqs?: Maybe<Array<Maybe<Faq>>>;
  faqsConnection?: Maybe<FaqConnection>;
  footer?: Maybe<Footer>;
  footers?: Maybe<Array<Maybe<Footer>>>;
  footersConnection?: Maybe<FooterConnection>;
  generoCategoria?: Maybe<GeneroCategorias>;
  generoCategorias?: Maybe<Array<Maybe<GeneroCategorias>>>;
  generoCategoriasConnection?: Maybe<GeneroCategoriasConnection>;
  header?: Maybe<Header>;
  headers?: Maybe<Array<Maybe<Header>>>;
  headersConnection?: Maybe<HeaderConnection>;
  lIstaDeSuscriptore?: Maybe<LIstaDeSuscriptores>;
  lIstaDeSuscriptores?: Maybe<Array<Maybe<LIstaDeSuscriptores>>>;
  lIstaDeSuscriptoresConnection?: Maybe<LIstaDeSuscriptoresConnection>;
  paginaDeContacto?: Maybe<PaginaDeContacto>;
  paginaDeContactos?: Maybe<Array<Maybe<PaginaDeContacto>>>;
  paginaDeContactosConnection?: Maybe<PaginaDeContactoConnection>;
  paginaSomo?: Maybe<PaginaSomos>;
  paginaSomos?: Maybe<Array<Maybe<PaginaSomos>>>;
  paginaSomosConnection?: Maybe<PaginaSomosConnection>;
  producto?: Maybe<Productos>;
  productos?: Maybe<Array<Maybe<Productos>>>;
  productosConnection?: Maybe<ProductosConnection>;
  prueba?: Maybe<Prueba>;
  pruebas?: Maybe<Array<Maybe<Prueba>>>;
  pruebasConnection?: Maybe<PruebaConnection>;
  tituloFaq?: Maybe<TituloFaq>;
  tituloFaqs?: Maybe<Array<Maybe<TituloFaq>>>;
  tituloFaqsConnection?: Maybe<TituloFaqConnection>;
  ventanasEmergente?: Maybe<VentanasEmergente>;
  ventanasEmergentes?: Maybe<Array<Maybe<VentanasEmergente>>>;
  ventanasEmergentesConnection?: Maybe<VentanasEmergenteConnection>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  me?: Maybe<UsersPermissionsMe>;
};


export type QueryCategoriasPrincipaleArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCategoriasPrincipalesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCategoriasPrincipalesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCategoriaArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCategoriasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCategoriasConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCodigoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCodigosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCodigosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryColoreArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryColoresArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryColoresConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCompraArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryComprasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryComprasConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryEnvioArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryEnviosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryEnviosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFaqArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryFaqsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryFaqsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFooterArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryFootersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryFootersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGeneroCategoriaArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryGeneroCategoriasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGeneroCategoriasConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryHeaderArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryHeadersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryHeadersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryLIstaDeSuscriptoreArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryLIstaDeSuscriptoresArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryLIstaDeSuscriptoresConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPaginaDeContactoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPaginaDeContactosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPaginaDeContactosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPaginaSomoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPaginaSomosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPaginaSomosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProductoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryProductosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryProductosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPruebaArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPruebasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPruebasConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTituloFaqArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTituloFaqsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTituloFaqsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryVentanasEmergenteArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryVentanasEmergentesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryVentanasEmergentesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryFilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryUsersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type RoleInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};


export type TituloFaq = {
  __typename?: 'TituloFaq';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Nombre?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  preguntas_respuestas?: Maybe<Array<Maybe<Faq>>>;
};


export type TituloFaqPreguntas_RespuestasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type TituloFaqAggregator = {
  __typename?: 'TituloFaqAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TituloFaqConnection = {
  __typename?: 'TituloFaqConnection';
  values?: Maybe<Array<Maybe<TituloFaq>>>;
  groupBy?: Maybe<TituloFaqGroupBy>;
  aggregate?: Maybe<TituloFaqAggregator>;
};

export type TituloFaqConnectionCreated_At = {
  __typename?: 'TituloFaqConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TituloFaqConnection>;
};

export type TituloFaqConnectionId = {
  __typename?: 'TituloFaqConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TituloFaqConnection>;
};

export type TituloFaqConnectionNombre = {
  __typename?: 'TituloFaqConnectionNombre';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TituloFaqConnection>;
};

export type TituloFaqConnectionPublished_At = {
  __typename?: 'TituloFaqConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TituloFaqConnection>;
};

export type TituloFaqConnectionUpdated_At = {
  __typename?: 'TituloFaqConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TituloFaqConnection>;
};

export type TituloFaqGroupBy = {
  __typename?: 'TituloFaqGroupBy';
  id?: Maybe<Array<Maybe<TituloFaqConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TituloFaqConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TituloFaqConnectionUpdated_At>>>;
  Nombre?: Maybe<Array<Maybe<TituloFaqConnectionNombre>>>;
  published_at?: Maybe<Array<Maybe<TituloFaqConnectionPublished_At>>>;
};

export type TituloFaqInput = {
  Nombre?: Maybe<Scalars['String']>;
  preguntas_respuestas?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};


export type UploadFile = {
  __typename?: 'UploadFile';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Morph>>>;
};


export type UploadFileRelatedArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UploadFileAggregator = {
  __typename?: 'UploadFileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<UploadFileAggregatorSum>;
  avg?: Maybe<UploadFileAggregatorAvg>;
  min?: Maybe<UploadFileAggregatorMin>;
  max?: Maybe<UploadFileAggregatorMax>;
};

export type UploadFileAggregatorAvg = {
  __typename?: 'UploadFileAggregatorAvg';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
  __typename?: 'UploadFileAggregatorMax';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
  __typename?: 'UploadFileAggregatorMin';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorSum = {
  __typename?: 'UploadFileAggregatorSum';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileConnection = {
  __typename?: 'UploadFileConnection';
  values?: Maybe<Array<Maybe<UploadFile>>>;
  groupBy?: Maybe<UploadFileGroupBy>;
  aggregate?: Maybe<UploadFileAggregator>;
};

export type UploadFileConnectionAlternativeText = {
  __typename?: 'UploadFileConnectionAlternativeText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCaption = {
  __typename?: 'UploadFileConnectionCaption';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreated_At = {
  __typename?: 'UploadFileConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionExt = {
  __typename?: 'UploadFileConnectionExt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionFormats = {
  __typename?: 'UploadFileConnectionFormats';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHash = {
  __typename?: 'UploadFileConnectionHash';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHeight = {
  __typename?: 'UploadFileConnectionHeight';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionId = {
  __typename?: 'UploadFileConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionMime = {
  __typename?: 'UploadFileConnectionMime';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionName = {
  __typename?: 'UploadFileConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionPreviewUrl = {
  __typename?: 'UploadFileConnectionPreviewUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider = {
  __typename?: 'UploadFileConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider_Metadata = {
  __typename?: 'UploadFileConnectionProvider_metadata';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionSize = {
  __typename?: 'UploadFileConnectionSize';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdated_At = {
  __typename?: 'UploadFileConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUrl = {
  __typename?: 'UploadFileConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionWidth = {
  __typename?: 'UploadFileConnectionWidth';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileGroupBy = {
  __typename?: 'UploadFileGroupBy';
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UploadFileConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UploadFileConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
};

export type UserInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UserPermissionsPasswordPayload = {
  __typename?: 'UserPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  id: Scalars['ID'];
  type: Scalars['String'];
  controller: Scalars['String'];
  action: Scalars['String'];
  enabled: Scalars['Boolean'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsRoleAggregator = {
  __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsRoleConnection = {
  __typename?: 'UsersPermissionsRoleConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
};

export type UsersPermissionsRoleConnectionDescription = {
  __typename?: 'UsersPermissionsRoleConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionId = {
  __typename?: 'UsersPermissionsRoleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionName = {
  __typename?: 'UsersPermissionsRoleConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionType = {
  __typename?: 'UsersPermissionsRoleConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleGroupBy = {
  __typename?: 'UsersPermissionsRoleGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsUserAggregator = {
  __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsUserConnection = {
  __typename?: 'UsersPermissionsUserConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
};

export type UsersPermissionsUserConnectionBlocked = {
  __typename?: 'UsersPermissionsUserConnectionBlocked';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionConfirmed = {
  __typename?: 'UsersPermissionsUserConnectionConfirmed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreated_At = {
  __typename?: 'UsersPermissionsUserConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionEmail = {
  __typename?: 'UsersPermissionsUserConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionId = {
  __typename?: 'UsersPermissionsUserConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProvider = {
  __typename?: 'UsersPermissionsUserConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionRole = {
  __typename?: 'UsersPermissionsUserConnectionRole';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdated_At = {
  __typename?: 'UsersPermissionsUserConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUsername = {
  __typename?: 'UsersPermissionsUserConnectionUsername';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserGroupBy = {
  __typename?: 'UsersPermissionsUserGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_At>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
};

export type VentanasEmergente = {
  __typename?: 'VentanasEmergente';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Titulo?: Maybe<Scalars['String']>;
  Texto?: Maybe<Scalars['String']>;
  TextoBoton?: Maybe<Scalars['String']>;
  Habilitado?: Maybe<Scalars['Boolean']>;
  PorcentajeDescuento?: Maybe<Scalars['String']>;
  logo?: Maybe<UploadFile>;
  published_at?: Maybe<Scalars['DateTime']>;
  Imagen?: Maybe<Array<Maybe<UploadFile>>>;
};


export type VentanasEmergenteImagenArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type VentanasEmergenteAggregator = {
  __typename?: 'VentanasEmergenteAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type VentanasEmergenteConnection = {
  __typename?: 'VentanasEmergenteConnection';
  values?: Maybe<Array<Maybe<VentanasEmergente>>>;
  groupBy?: Maybe<VentanasEmergenteGroupBy>;
  aggregate?: Maybe<VentanasEmergenteAggregator>;
};

export type VentanasEmergenteConnectionCreated_At = {
  __typename?: 'VentanasEmergenteConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VentanasEmergenteConnection>;
};

export type VentanasEmergenteConnectionHabilitado = {
  __typename?: 'VentanasEmergenteConnectionHabilitado';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<VentanasEmergenteConnection>;
};

export type VentanasEmergenteConnectionId = {
  __typename?: 'VentanasEmergenteConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VentanasEmergenteConnection>;
};

export type VentanasEmergenteConnectionLogo = {
  __typename?: 'VentanasEmergenteConnectionLogo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VentanasEmergenteConnection>;
};

export type VentanasEmergenteConnectionPorcentajeDescuento = {
  __typename?: 'VentanasEmergenteConnectionPorcentajeDescuento';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VentanasEmergenteConnection>;
};

export type VentanasEmergenteConnectionPublished_At = {
  __typename?: 'VentanasEmergenteConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VentanasEmergenteConnection>;
};

export type VentanasEmergenteConnectionTexto = {
  __typename?: 'VentanasEmergenteConnectionTexto';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VentanasEmergenteConnection>;
};

export type VentanasEmergenteConnectionTextoBoton = {
  __typename?: 'VentanasEmergenteConnectionTextoBoton';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VentanasEmergenteConnection>;
};

export type VentanasEmergenteConnectionTitulo = {
  __typename?: 'VentanasEmergenteConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VentanasEmergenteConnection>;
};

export type VentanasEmergenteConnectionUpdated_At = {
  __typename?: 'VentanasEmergenteConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VentanasEmergenteConnection>;
};

export type VentanasEmergenteGroupBy = {
  __typename?: 'VentanasEmergenteGroupBy';
  id?: Maybe<Array<Maybe<VentanasEmergenteConnectionId>>>;
  created_at?: Maybe<Array<Maybe<VentanasEmergenteConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<VentanasEmergenteConnectionUpdated_At>>>;
  Titulo?: Maybe<Array<Maybe<VentanasEmergenteConnectionTitulo>>>;
  Texto?: Maybe<Array<Maybe<VentanasEmergenteConnectionTexto>>>;
  TextoBoton?: Maybe<Array<Maybe<VentanasEmergenteConnectionTextoBoton>>>;
  Habilitado?: Maybe<Array<Maybe<VentanasEmergenteConnectionHabilitado>>>;
  PorcentajeDescuento?: Maybe<Array<Maybe<VentanasEmergenteConnectionPorcentajeDescuento>>>;
  logo?: Maybe<Array<Maybe<VentanasEmergenteConnectionLogo>>>;
  published_at?: Maybe<Array<Maybe<VentanasEmergenteConnectionPublished_At>>>;
};

export type VentanasEmergenteInput = {
  Imagen?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Titulo?: Maybe<Scalars['String']>;
  Texto?: Maybe<Scalars['String']>;
  TextoBoton?: Maybe<Scalars['String']>;
  Habilitado?: Maybe<Scalars['Boolean']>;
  PorcentajeDescuento?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateCategoriaInput = {
  data?: Maybe<CategoriaInput>;
};

export type CreateCategoriaPayload = {
  __typename?: 'createCategoriaPayload';
  categoria?: Maybe<Categorias>;
};

export type CreateCategoriasPrincipaleInput = {
  data?: Maybe<CategoriasPrincipaleInput>;
};

export type CreateCategoriasPrincipalePayload = {
  __typename?: 'createCategoriasPrincipalePayload';
  categoriasPrincipale?: Maybe<CategoriasPrincipales>;
};

export type CreateCodigoInput = {
  data?: Maybe<CodigoInput>;
};

export type CreateCodigoPayload = {
  __typename?: 'createCodigoPayload';
  codigo?: Maybe<Codigos>;
};

export type CreateColoreInput = {
  data?: Maybe<ColoreInput>;
};

export type CreateColorePayload = {
  __typename?: 'createColorePayload';
  colore?: Maybe<Colores>;
};

export type CreateCompraInput = {
  data?: Maybe<CompraInput>;
};

export type CreateCompraPayload = {
  __typename?: 'createCompraPayload';
  compra?: Maybe<Compra>;
};

export type CreateEnvioInput = {
  data?: Maybe<EnvioInput>;
};

export type CreateEnvioPayload = {
  __typename?: 'createEnvioPayload';
  envio?: Maybe<Envios>;
};

export type CreateFaqInput = {
  data?: Maybe<FaqInput>;
};

export type CreateFaqPayload = {
  __typename?: 'createFaqPayload';
  faq?: Maybe<Faq>;
};

export type CreateFooterInput = {
  data?: Maybe<FooterInput>;
};

export type CreateFooterPayload = {
  __typename?: 'createFooterPayload';
  footer?: Maybe<Footer>;
};

export type CreateGeneroCategoriaInput = {
  data?: Maybe<GeneroCategoriaInput>;
};

export type CreateGeneroCategoriaPayload = {
  __typename?: 'createGeneroCategoriaPayload';
  generoCategoria?: Maybe<GeneroCategorias>;
};

export type CreateHeaderInput = {
  data?: Maybe<HeaderInput>;
};

export type CreateHeaderPayload = {
  __typename?: 'createHeaderPayload';
  header?: Maybe<Header>;
};

export type CreateLIstaDeSuscriptoreInput = {
  data?: Maybe<LIstaDeSuscriptoreInput>;
};

export type CreateLIstaDeSuscriptorePayload = {
  __typename?: 'createLIstaDeSuscriptorePayload';
  lIstaDeSuscriptore?: Maybe<LIstaDeSuscriptores>;
};

export type CreatePaginaDeContactoInput = {
  data?: Maybe<PaginaDeContactoInput>;
};

export type CreatePaginaDeContactoPayload = {
  __typename?: 'createPaginaDeContactoPayload';
  paginaDeContacto?: Maybe<PaginaDeContacto>;
};

export type CreatePaginaSomoInput = {
  data?: Maybe<PaginaSomoInput>;
};

export type CreatePaginaSomoPayload = {
  __typename?: 'createPaginaSomoPayload';
  paginaSomo?: Maybe<PaginaSomos>;
};

export type CreateProductoInput = {
  data?: Maybe<ProductoInput>;
};

export type CreateProductoPayload = {
  __typename?: 'createProductoPayload';
  producto?: Maybe<Productos>;
};

export type CreatePruebaInput = {
  data?: Maybe<PruebaInput>;
};

export type CreatePruebaPayload = {
  __typename?: 'createPruebaPayload';
  prueba?: Maybe<Prueba>;
};

export type CreateRoleInput = {
  data?: Maybe<RoleInput>;
};

export type CreateRolePayload = {
  __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type CreateTituloFaqInput = {
  data?: Maybe<TituloFaqInput>;
};

export type CreateTituloFaqPayload = {
  __typename?: 'createTituloFaqPayload';
  tituloFaq?: Maybe<TituloFaq>;
};

export type CreateUserInput = {
  data?: Maybe<UserInput>;
};

export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type CreateVentanasEmergenteInput = {
  data?: Maybe<VentanasEmergenteInput>;
};

export type CreateVentanasEmergentePayload = {
  __typename?: 'createVentanasEmergentePayload';
  ventanasEmergente?: Maybe<VentanasEmergente>;
};

export type DeleteCategoriaInput = {
  where?: Maybe<InputId>;
};

export type DeleteCategoriaPayload = {
  __typename?: 'deleteCategoriaPayload';
  categoria?: Maybe<Categorias>;
};

export type DeleteCategoriasPrincipaleInput = {
  where?: Maybe<InputId>;
};

export type DeleteCategoriasPrincipalePayload = {
  __typename?: 'deleteCategoriasPrincipalePayload';
  categoriasPrincipale?: Maybe<CategoriasPrincipales>;
};

export type DeleteCodigoInput = {
  where?: Maybe<InputId>;
};

export type DeleteCodigoPayload = {
  __typename?: 'deleteCodigoPayload';
  codigo?: Maybe<Codigos>;
};

export type DeleteColoreInput = {
  where?: Maybe<InputId>;
};

export type DeleteColorePayload = {
  __typename?: 'deleteColorePayload';
  colore?: Maybe<Colores>;
};

export type DeleteCompraInput = {
  where?: Maybe<InputId>;
};

export type DeleteCompraPayload = {
  __typename?: 'deleteCompraPayload';
  compra?: Maybe<Compra>;
};

export type DeleteEnvioInput = {
  where?: Maybe<InputId>;
};

export type DeleteEnvioPayload = {
  __typename?: 'deleteEnvioPayload';
  envio?: Maybe<Envios>;
};

export type DeleteFaqInput = {
  where?: Maybe<InputId>;
};

export type DeleteFaqPayload = {
  __typename?: 'deleteFaqPayload';
  faq?: Maybe<Faq>;
};

export type DeleteFileInput = {
  where?: Maybe<InputId>;
};

export type DeleteFilePayload = {
  __typename?: 'deleteFilePayload';
  file?: Maybe<UploadFile>;
};

export type DeleteFooterInput = {
  where?: Maybe<InputId>;
};

export type DeleteFooterPayload = {
  __typename?: 'deleteFooterPayload';
  footer?: Maybe<Footer>;
};

export type DeleteGeneroCategoriaInput = {
  where?: Maybe<InputId>;
};

export type DeleteGeneroCategoriaPayload = {
  __typename?: 'deleteGeneroCategoriaPayload';
  generoCategoria?: Maybe<GeneroCategorias>;
};

export type DeleteHeaderInput = {
  where?: Maybe<InputId>;
};

export type DeleteHeaderPayload = {
  __typename?: 'deleteHeaderPayload';
  header?: Maybe<Header>;
};

export type DeleteLIstaDeSuscriptoreInput = {
  where?: Maybe<InputId>;
};

export type DeleteLIstaDeSuscriptorePayload = {
  __typename?: 'deleteLIstaDeSuscriptorePayload';
  lIstaDeSuscriptore?: Maybe<LIstaDeSuscriptores>;
};

export type DeletePaginaDeContactoInput = {
  where?: Maybe<InputId>;
};

export type DeletePaginaDeContactoPayload = {
  __typename?: 'deletePaginaDeContactoPayload';
  paginaDeContacto?: Maybe<PaginaDeContacto>;
};

export type DeletePaginaSomoInput = {
  where?: Maybe<InputId>;
};

export type DeletePaginaSomoPayload = {
  __typename?: 'deletePaginaSomoPayload';
  paginaSomo?: Maybe<PaginaSomos>;
};

export type DeleteProductoInput = {
  where?: Maybe<InputId>;
};

export type DeleteProductoPayload = {
  __typename?: 'deleteProductoPayload';
  producto?: Maybe<Productos>;
};

export type DeletePruebaInput = {
  where?: Maybe<InputId>;
};

export type DeletePruebaPayload = {
  __typename?: 'deletePruebaPayload';
  prueba?: Maybe<Prueba>;
};

export type DeleteRoleInput = {
  where?: Maybe<InputId>;
};

export type DeleteRolePayload = {
  __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteTituloFaqInput = {
  where?: Maybe<InputId>;
};

export type DeleteTituloFaqPayload = {
  __typename?: 'deleteTituloFaqPayload';
  tituloFaq?: Maybe<TituloFaq>;
};

export type DeleteUserInput = {
  where?: Maybe<InputId>;
};

export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteVentanasEmergenteInput = {
  where?: Maybe<InputId>;
};

export type DeleteVentanasEmergentePayload = {
  __typename?: 'deleteVentanasEmergentePayload';
  ventanasEmergente?: Maybe<VentanasEmergente>;
};

export type EditCategoriaInput = {
  Nombre?: Maybe<Scalars['String']>;
  productos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Hombre?: Maybe<Scalars['Boolean']>;
  Mujer?: Maybe<Scalars['Boolean']>;
  CategoriaDestacada?: Maybe<Scalars['Boolean']>;
  MostrarEnMenu?: Maybe<Scalars['Boolean']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditCategoriasPrincipaleInput = {
  TituloHombre?: Maybe<Scalars['String']>;
  TituloMujer?: Maybe<Scalars['String']>;
  SubtituloHombre?: Maybe<Scalars['String']>;
  SubtituloMujer?: Maybe<Scalars['String']>;
  TituloBotonHombre?: Maybe<Scalars['String']>;
  TituloBotonMujer?: Maybe<Scalars['String']>;
  ImagenHombre?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ImagenMujer?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditCodigoInput = {
  Codigo?: Maybe<Scalars['String']>;
  ValorDescuento?: Maybe<Scalars['Float']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditColoreInput = {
  NombreColor?: Maybe<Scalars['String']>;
  productos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  CodigoColor?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditCompraInput = {
  Nombres?: Maybe<Scalars['String']>;
  Apellidos?: Maybe<Scalars['String']>;
  NombreCalle?: Maybe<Scalars['String']>;
  NombreApartamento?: Maybe<Scalars['String']>;
  NombreCiudad?: Maybe<Scalars['String']>;
  NombreBarrio?: Maybe<Scalars['String']>;
  CodigoPostal?: Maybe<Scalars['Long']>;
  NumeroTelefono?: Maybe<Scalars['String']>;
  Correo?: Maybe<Scalars['String']>;
  productos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditEnvioInput = {
  EnvioLocal?: Maybe<Scalars['String']>;
  EnvioNacional?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditFaqInput = {
  Pregunta?: Maybe<Scalars['String']>;
  titulo_faq?: Maybe<Scalars['ID']>;
  Respuesta?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditFooterInput = {
  TextoWhatsapp?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  imagenes_metodos_de_pago?: Maybe<Scalars['ID']>;
  Facebook?: Maybe<Scalars['String']>;
  Instagram?: Maybe<Scalars['String']>;
  LinkWhatsapp?: Maybe<Scalars['String']>;
  NumeroWhatsapp?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditGeneroCategoriaInput = {
  Imagen?: Maybe<Scalars['ID']>;
  Titulo?: Maybe<Scalars['String']>;
  TituloBoton?: Maybe<Scalars['String']>;
  LinkEscribenos?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditHeaderInput = {
  Facebook?: Maybe<Scalars['String']>;
  Instagram?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  NumeroTelefono?: Maybe<Scalars['String']>;
  TextoDescuento?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditLIstaDeSuscriptoreInput = {
  Correo?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPaginaDeContactoInput = {
  Imagen?: Maybe<Scalars['ID']>;
  Titulo_oficina?: Maybe<Scalars['String']>;
  Texto_oficina?: Maybe<Scalars['String']>;
  titulo_informacion_contacto?: Maybe<Scalars['String']>;
  texto_informacion_contacto?: Maybe<Scalars['String']>;
  titulo_redes?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  Titulo_imagen?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPaginaSomoInput = {
  BannerImagen?: Maybe<Array<Maybe<Scalars['ID']>>>;
  SubtituloImagen?: Maybe<Scalars['String']>;
  TextoVision?: Maybe<Scalars['String']>;
  TextoMision?: Maybe<Scalars['String']>;
  TituloImagen?: Maybe<Scalars['String']>;
  TextoPrincipal?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditProductoInput = {
  Titulo?: Maybe<Scalars['String']>;
  Descripcion?: Maybe<Scalars['String']>;
  SKU?: Maybe<Scalars['String']>;
  Imagenes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Nuevo?: Maybe<Scalars['Boolean']>;
  Descuento?: Maybe<Scalars['Boolean']>;
  precio?: Maybe<Scalars['Long']>;
  categoria?: Maybe<Scalars['ID']>;
  salePrice?: Maybe<Scalars['Long']>;
  Destacado?: Maybe<Scalars['Boolean']>;
  colores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPruebaInput = {
  TextoBoton?: Maybe<Scalars['String']>;
  Imagen_1?: Maybe<Array<Maybe<Scalars['ID']>>>;
  UrlBoton?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTituloFaqInput = {
  Nombre?: Maybe<Scalars['String']>;
  preguntas_respuestas?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditVentanasEmergenteInput = {
  Imagen?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Titulo?: Maybe<Scalars['String']>;
  Texto?: Maybe<Scalars['String']>;
  TextoBoton?: Maybe<Scalars['String']>;
  Habilitado?: Maybe<Scalars['Boolean']>;
  PorcentajeDescuento?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateCategoriaInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCategoriaInput>;
};

export type UpdateCategoriaPayload = {
  __typename?: 'updateCategoriaPayload';
  categoria?: Maybe<Categorias>;
};

export type UpdateCategoriasPrincipaleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCategoriasPrincipaleInput>;
};

export type UpdateCategoriasPrincipalePayload = {
  __typename?: 'updateCategoriasPrincipalePayload';
  categoriasPrincipale?: Maybe<CategoriasPrincipales>;
};

export type UpdateCodigoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCodigoInput>;
};

export type UpdateCodigoPayload = {
  __typename?: 'updateCodigoPayload';
  codigo?: Maybe<Codigos>;
};

export type UpdateColoreInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditColoreInput>;
};

export type UpdateColorePayload = {
  __typename?: 'updateColorePayload';
  colore?: Maybe<Colores>;
};

export type UpdateCompraInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCompraInput>;
};

export type UpdateCompraPayload = {
  __typename?: 'updateCompraPayload';
  compra?: Maybe<Compra>;
};

export type UpdateEnvioInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditEnvioInput>;
};

export type UpdateEnvioPayload = {
  __typename?: 'updateEnvioPayload';
  envio?: Maybe<Envios>;
};

export type UpdateFaqInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditFaqInput>;
};

export type UpdateFaqPayload = {
  __typename?: 'updateFaqPayload';
  faq?: Maybe<Faq>;
};

export type UpdateFooterInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditFooterInput>;
};

export type UpdateFooterPayload = {
  __typename?: 'updateFooterPayload';
  footer?: Maybe<Footer>;
};

export type UpdateGeneroCategoriaInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditGeneroCategoriaInput>;
};

export type UpdateGeneroCategoriaPayload = {
  __typename?: 'updateGeneroCategoriaPayload';
  generoCategoria?: Maybe<GeneroCategorias>;
};

export type UpdateHeaderInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditHeaderInput>;
};

export type UpdateHeaderPayload = {
  __typename?: 'updateHeaderPayload';
  header?: Maybe<Header>;
};

export type UpdateLIstaDeSuscriptoreInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditLIstaDeSuscriptoreInput>;
};

export type UpdateLIstaDeSuscriptorePayload = {
  __typename?: 'updateLIstaDeSuscriptorePayload';
  lIstaDeSuscriptore?: Maybe<LIstaDeSuscriptores>;
};

export type UpdatePaginaDeContactoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPaginaDeContactoInput>;
};

export type UpdatePaginaDeContactoPayload = {
  __typename?: 'updatePaginaDeContactoPayload';
  paginaDeContacto?: Maybe<PaginaDeContacto>;
};

export type UpdatePaginaSomoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPaginaSomoInput>;
};

export type UpdatePaginaSomoPayload = {
  __typename?: 'updatePaginaSomoPayload';
  paginaSomo?: Maybe<PaginaSomos>;
};

export type UpdateProductoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditProductoInput>;
};

export type UpdateProductoPayload = {
  __typename?: 'updateProductoPayload';
  producto?: Maybe<Productos>;
};

export type UpdatePruebaInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPruebaInput>;
};

export type UpdatePruebaPayload = {
  __typename?: 'updatePruebaPayload';
  prueba?: Maybe<Prueba>;
};

export type UpdateRoleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRoleInput>;
};

export type UpdateRolePayload = {
  __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateTituloFaqInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTituloFaqInput>;
};

export type UpdateTituloFaqPayload = {
  __typename?: 'updateTituloFaqPayload';
  tituloFaq?: Maybe<TituloFaq>;
};

export type UpdateUserInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUserInput>;
};

export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type UpdateVentanasEmergenteInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditVentanasEmergenteInput>;
};

export type UpdateVentanasEmergentePayload = {
  __typename?: 'updateVentanasEmergentePayload';
  ventanasEmergente?: Maybe<VentanasEmergente>;
};

export type RegularCategoriaPrincipalFragment = (
  { __typename?: 'CategoriasPrincipales' }
  & Pick<CategoriasPrincipales, 'id' | 'TituloHombre' | 'TituloMujer' | 'SubtituloHombre' | 'SubtituloMujer' | 'TituloBotonHombre' | 'TituloBotonMujer'>
  & { ImagenHombre?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'url'>
  )>>>, ImagenMujer?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'url'>
  )>>> }
);

export type RegularContactoFragment = (
  { __typename?: 'PaginaDeContacto' }
  & Pick<PaginaDeContacto, 'instagram' | 'Titulo_imagen' | 'Titulo_oficina' | 'Texto_oficina' | 'titulo_informacion_contacto' | 'texto_informacion_contacto' | 'titulo_redes' | 'facebook'>
  & { Imagen?: Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'url'>
  )> }
);

export type RegularFaqFragment = (
  { __typename?: 'Faq' }
  & Pick<Faq, 'id' | 'Pregunta' | 'Respuesta'>
);

export type RegularFooterFragment = (
  { __typename?: 'Footer' }
  & Pick<Footer, 'LinkWhatsapp' | 'TextoWhatsapp' | 'NumeroWhatsapp' | 'Facebook' | 'Instagram'>
);

export type RegularHeaderFragment = (
  { __typename?: 'Header' }
  & Pick<Header, 'NumeroTelefono' | 'Facebook' | 'Instagram' | 'TextoDescuento'>
  & { logo?: Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'url'>
  )> }
);

export type RegularPopupFragment = (
  { __typename?: 'VentanasEmergente' }
  & Pick<VentanasEmergente, 'id' | 'Titulo' | 'Texto' | 'TextoBoton' | 'Habilitado' | 'PorcentajeDescuento'>
  & { Imagen?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'url'>
  )>>> }
);

export type RegularPortadaFragment = (
  { __typename?: 'Prueba' }
  & Pick<Prueba, 'id' | 'TextoBoton' | 'UrlBoton'>
  & { Imagen_1?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'url'>
  )>>> }
);

export type RegularProductoFragment = (
  { __typename?: 'Productos' }
  & Pick<Productos, 'id' | 'salePrice' | 'Titulo' | 'Descripcion' | 'SKU' | 'Nuevo' | 'Descuento' | 'precio' | 'Destacado'>
  & { categoria?: Maybe<(
    { __typename?: 'Categorias' }
    & Pick<Categorias, 'Nombre' | 'id' | 'Hombre' | 'Mujer'>
  )>, Imagenes?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'url'>
  )>>>, colores?: Maybe<Array<Maybe<(
    { __typename?: 'Colores' }
    & Pick<Colores, 'id' | 'CodigoColor' | 'NombreColor'>
  )>>> }
);

export type RegularSomosFragment = (
  { __typename?: 'PaginaSomos' }
  & Pick<PaginaSomos, 'id' | 'SubtituloImagen' | 'TextoVision' | 'TextoMision' | 'TituloImagen' | 'TextoPrincipal'>
  & { BannerImagen?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'url'>
  )>>> }
);

export type AddPurchaseMutationVariables = Exact<{
  input?: Maybe<CreateCompraInput>;
}>;


export type AddPurchaseMutation = (
  { __typename?: 'Mutation' }
  & { createCompra?: Maybe<(
    { __typename?: 'createCompraPayload' }
    & { compra?: Maybe<(
      { __typename?: 'Compra' }
      & Pick<Compra, 'id'>
    )> }
  )> }
);

export type AddSuscriptionMutationVariables = Exact<{
  input: CreateLIstaDeSuscriptoreInput;
}>;


export type AddSuscriptionMutation = (
  { __typename?: 'Mutation' }
  & { createLIstaDeSuscriptore?: Maybe<{ __typename: 'createLIstaDeSuscriptorePayload' }> }
);

export type GetAboutQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAboutQuery = (
  { __typename?: 'Query' }
  & { paginaSomos?: Maybe<Array<Maybe<(
    { __typename?: 'PaginaSomos' }
    & RegularSomosFragment
  )>>> }
);

export type GetContactQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactQuery = (
  { __typename?: 'Query' }
  & { paginaDeContactos?: Maybe<Array<Maybe<(
    { __typename?: 'PaginaDeContacto' }
    & RegularContactoFragment
  )>>> }
);

export type GetDiscountQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetDiscountQuery = (
  { __typename?: 'Query' }
  & { codigos?: Maybe<Array<Maybe<(
    { __typename?: 'Codigos' }
    & Pick<Codigos, 'id' | 'Codigo' | 'ValorDescuento'>
  )>>> }
);

export type GetEnviosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEnviosQuery = (
  { __typename?: 'Query' }
  & { envios?: Maybe<Array<Maybe<(
    { __typename?: 'Envios' }
    & Pick<Envios, 'EnvioNacional' | 'EnvioLocal'>
  )>>> }
);

export type GetFaqQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFaqQuery = (
  { __typename?: 'Query' }
  & { tituloFaqs?: Maybe<Array<Maybe<(
    { __typename?: 'TituloFaq' }
    & Pick<TituloFaq, 'id' | 'Nombre'>
    & { preguntas_respuestas?: Maybe<Array<Maybe<(
      { __typename?: 'Faq' }
      & RegularFaqFragment
    )>>> }
  )>>> }
);

export type GetLandQueryVariables = Exact<{
  where: Scalars['JSON'];
}>;


export type GetLandQuery = (
  { __typename?: 'Query' }
  & { pruebas?: Maybe<Array<Maybe<(
    { __typename?: 'Prueba' }
    & RegularPortadaFragment
  )>>>, categoriasPrincipales?: Maybe<Array<Maybe<(
    { __typename?: 'CategoriasPrincipales' }
    & RegularCategoriaPrincipalFragment
  )>>>, productos?: Maybe<Array<Maybe<(
    { __typename?: 'Productos' }
    & RegularProductoFragment
  )>>>, categorias?: Maybe<Array<Maybe<(
    { __typename?: 'Categorias' }
    & Pick<Categorias, 'id' | 'Nombre'>
  )>>>, ventanasEmergentes?: Maybe<Array<Maybe<(
    { __typename?: 'VentanasEmergente' }
    & RegularPopupFragment
  )>>>, generoCategorias?: Maybe<Array<Maybe<(
    { __typename?: 'GeneroCategorias' }
    & Pick<GeneroCategorias, 'Titulo' | 'TituloBoton' | 'LinkEscribenos'>
    & { Imagen?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )> }
  )>>> }
);

export type GetNavQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNavQuery = (
  { __typename?: 'Query' }
  & { headers?: Maybe<Array<Maybe<(
    { __typename?: 'Header' }
    & RegularHeaderFragment
  )>>>, footers?: Maybe<Array<Maybe<(
    { __typename?: 'Footer' }
    & RegularFooterFragment
  )>>>, categorias?: Maybe<Array<Maybe<(
    { __typename?: 'Categorias' }
    & Pick<Categorias, 'Nombre' | 'MostrarEnMenu' | 'id'>
  )>>> }
);

export type GetProductQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetProductQuery = (
  { __typename?: 'Query' }
  & { productos?: Maybe<Array<Maybe<(
    { __typename?: 'Productos' }
    & RegularProductoFragment
  )>>> }
);

export type GetProductsQueryVariables = Exact<{
  limit: Scalars['Int'];
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type GetProductsQuery = (
  { __typename?: 'Query' }
  & { productos?: Maybe<Array<Maybe<(
    { __typename?: 'Productos' }
    & RegularProductoFragment
  )>>> }
);

export const RegularCategoriaPrincipalFragmentDoc = gql`
    fragment RegularCategoriaPrincipal on CategoriasPrincipales {
  id
  ImagenHombre {
    url
  }
  ImagenMujer {
    url
  }
  TituloHombre
  TituloMujer
  SubtituloHombre
  SubtituloMujer
  TituloBotonHombre
  TituloBotonMujer
}
    `;
export const RegularContactoFragmentDoc = gql`
    fragment RegularContacto on PaginaDeContacto {
  instagram
  Titulo_imagen
  Imagen {
    url
  }
  Titulo_oficina
  Texto_oficina
  titulo_informacion_contacto
  texto_informacion_contacto
  titulo_redes
  facebook
}
    `;
export const RegularFaqFragmentDoc = gql`
    fragment RegularFaq on Faq {
  id
  Pregunta
  Respuesta
}
    `;
export const RegularFooterFragmentDoc = gql`
    fragment RegularFooter on Footer {
  LinkWhatsapp
  TextoWhatsapp
  NumeroWhatsapp
  Facebook
  Instagram
}
    `;
export const RegularHeaderFragmentDoc = gql`
    fragment RegularHeader on Header {
  NumeroTelefono
  Facebook
  Instagram
  logo {
    url
  }
  TextoDescuento
}
    `;
export const RegularPopupFragmentDoc = gql`
    fragment RegularPopup on VentanasEmergente {
  id
  Imagen {
    url
  }
  Titulo
  Texto
  TextoBoton
  Habilitado
  PorcentajeDescuento
}
    `;
export const RegularPortadaFragmentDoc = gql`
    fragment RegularPortada on Prueba {
  id
  Imagen_1 {
    url
  }
  TextoBoton
  UrlBoton
}
    `;
export const RegularProductoFragmentDoc = gql`
    fragment RegularProducto on Productos {
  id
  categoria {
    Nombre
    id
    Hombre
    Mujer
  }
  salePrice
  Imagenes {
    url
  }
  Titulo
  Descripcion
  SKU
  Nuevo
  Descuento
  precio
  Destacado
  colores {
    id
    CodigoColor
    NombreColor
  }
}
    `;
export const RegularSomosFragmentDoc = gql`
    fragment RegularSomos on PaginaSomos {
  id
  SubtituloImagen
  TextoVision
  TextoMision
  TituloImagen
  TextoPrincipal
  BannerImagen {
    url
  }
}
    `;
export const AddPurchaseDocument = gql`
    mutation AddPurchase($input: createCompraInput) {
  createCompra(input: $input) {
    compra {
      id
    }
  }
}
    `;
export type AddPurchaseMutationFn = Apollo.MutationFunction<AddPurchaseMutation, AddPurchaseMutationVariables>;

/**
 * __useAddPurchaseMutation__
 *
 * To run a mutation, you first call `useAddPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPurchaseMutation, { data, loading, error }] = useAddPurchaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPurchaseMutation(baseOptions?: Apollo.MutationHookOptions<AddPurchaseMutation, AddPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPurchaseMutation, AddPurchaseMutationVariables>(AddPurchaseDocument, options);
      }
export type AddPurchaseMutationHookResult = ReturnType<typeof useAddPurchaseMutation>;
export type AddPurchaseMutationResult = Apollo.MutationResult<AddPurchaseMutation>;
export type AddPurchaseMutationOptions = Apollo.BaseMutationOptions<AddPurchaseMutation, AddPurchaseMutationVariables>;
export const AddSuscriptionDocument = gql`
    mutation AddSuscription($input: createLIstaDeSuscriptoreInput!) {
  createLIstaDeSuscriptore(input: $input) {
    __typename
  }
}
    `;
export type AddSuscriptionMutationFn = Apollo.MutationFunction<AddSuscriptionMutation, AddSuscriptionMutationVariables>;

/**
 * __useAddSuscriptionMutation__
 *
 * To run a mutation, you first call `useAddSuscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSuscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSuscriptionMutation, { data, loading, error }] = useAddSuscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSuscriptionMutation(baseOptions?: Apollo.MutationHookOptions<AddSuscriptionMutation, AddSuscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSuscriptionMutation, AddSuscriptionMutationVariables>(AddSuscriptionDocument, options);
      }
export type AddSuscriptionMutationHookResult = ReturnType<typeof useAddSuscriptionMutation>;
export type AddSuscriptionMutationResult = Apollo.MutationResult<AddSuscriptionMutation>;
export type AddSuscriptionMutationOptions = Apollo.BaseMutationOptions<AddSuscriptionMutation, AddSuscriptionMutationVariables>;
export const GetAboutDocument = gql`
    query GetAbout {
  paginaSomos(limit: 1) {
    ...RegularSomos
  }
}
    ${RegularSomosFragmentDoc}`;

/**
 * __useGetAboutQuery__
 *
 * To run a query within a React component, call `useGetAboutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAboutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAboutQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAboutQuery(baseOptions?: Apollo.QueryHookOptions<GetAboutQuery, GetAboutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAboutQuery, GetAboutQueryVariables>(GetAboutDocument, options);
      }
export function useGetAboutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAboutQuery, GetAboutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAboutQuery, GetAboutQueryVariables>(GetAboutDocument, options);
        }
export type GetAboutQueryHookResult = ReturnType<typeof useGetAboutQuery>;
export type GetAboutLazyQueryHookResult = ReturnType<typeof useGetAboutLazyQuery>;
export type GetAboutQueryResult = Apollo.QueryResult<GetAboutQuery, GetAboutQueryVariables>;
export const GetContactDocument = gql`
    query GetContact {
  paginaDeContactos(limit: 1) {
    ...RegularContacto
  }
}
    ${RegularContactoFragmentDoc}`;

/**
 * __useGetContactQuery__
 *
 * To run a query within a React component, call `useGetContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactQuery(baseOptions?: Apollo.QueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
      }
export function useGetContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
        }
export type GetContactQueryHookResult = ReturnType<typeof useGetContactQuery>;
export type GetContactLazyQueryHookResult = ReturnType<typeof useGetContactLazyQuery>;
export type GetContactQueryResult = Apollo.QueryResult<GetContactQuery, GetContactQueryVariables>;
export const GetDiscountDocument = gql`
    query GetDiscount($code: String!) {
  codigos(where: {Codigo: $code}, limit: 1) {
    id
    Codigo
    ValorDescuento
  }
}
    `;

/**
 * __useGetDiscountQuery__
 *
 * To run a query within a React component, call `useGetDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetDiscountQuery(baseOptions: Apollo.QueryHookOptions<GetDiscountQuery, GetDiscountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountQuery, GetDiscountQueryVariables>(GetDiscountDocument, options);
      }
export function useGetDiscountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountQuery, GetDiscountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountQuery, GetDiscountQueryVariables>(GetDiscountDocument, options);
        }
export type GetDiscountQueryHookResult = ReturnType<typeof useGetDiscountQuery>;
export type GetDiscountLazyQueryHookResult = ReturnType<typeof useGetDiscountLazyQuery>;
export type GetDiscountQueryResult = Apollo.QueryResult<GetDiscountQuery, GetDiscountQueryVariables>;
export const GetEnviosDocument = gql`
    query GetEnvios {
  envios(limit: 1) {
    EnvioNacional
    EnvioLocal
  }
}
    `;

/**
 * __useGetEnviosQuery__
 *
 * To run a query within a React component, call `useGetEnviosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnviosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnviosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEnviosQuery(baseOptions?: Apollo.QueryHookOptions<GetEnviosQuery, GetEnviosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnviosQuery, GetEnviosQueryVariables>(GetEnviosDocument, options);
      }
export function useGetEnviosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnviosQuery, GetEnviosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnviosQuery, GetEnviosQueryVariables>(GetEnviosDocument, options);
        }
export type GetEnviosQueryHookResult = ReturnType<typeof useGetEnviosQuery>;
export type GetEnviosLazyQueryHookResult = ReturnType<typeof useGetEnviosLazyQuery>;
export type GetEnviosQueryResult = Apollo.QueryResult<GetEnviosQuery, GetEnviosQueryVariables>;
export const GetFaqDocument = gql`
    query GetFaq {
  tituloFaqs {
    id
    Nombre
    preguntas_respuestas {
      ...RegularFaq
    }
  }
}
    ${RegularFaqFragmentDoc}`;

/**
 * __useGetFaqQuery__
 *
 * To run a query within a React component, call `useGetFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFaqQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFaqQuery(baseOptions?: Apollo.QueryHookOptions<GetFaqQuery, GetFaqQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFaqQuery, GetFaqQueryVariables>(GetFaqDocument, options);
      }
export function useGetFaqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFaqQuery, GetFaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFaqQuery, GetFaqQueryVariables>(GetFaqDocument, options);
        }
export type GetFaqQueryHookResult = ReturnType<typeof useGetFaqQuery>;
export type GetFaqLazyQueryHookResult = ReturnType<typeof useGetFaqLazyQuery>;
export type GetFaqQueryResult = Apollo.QueryResult<GetFaqQuery, GetFaqQueryVariables>;
export const GetLandDocument = gql`
    query GetLand($where: JSON!) {
  pruebas {
    ...RegularPortada
  }
  categoriasPrincipales {
    ...RegularCategoriaPrincipal
  }
  productos(where: $where, limit: 4) {
    ...RegularProducto
  }
  categorias(where: {CategoriaDestacada: true}, limit: 10) {
    id
    Nombre
  }
  ventanasEmergentes(limit: 1, where: {Habilitado: true}) {
    ...RegularPopup
  }
  generoCategorias(limit: 1) {
    Imagen {
      url
    }
    Titulo
    TituloBoton
    LinkEscribenos
  }
}
    ${RegularPortadaFragmentDoc}
${RegularCategoriaPrincipalFragmentDoc}
${RegularProductoFragmentDoc}
${RegularPopupFragmentDoc}`;

/**
 * __useGetLandQuery__
 *
 * To run a query within a React component, call `useGetLandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetLandQuery(baseOptions: Apollo.QueryHookOptions<GetLandQuery, GetLandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLandQuery, GetLandQueryVariables>(GetLandDocument, options);
      }
export function useGetLandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandQuery, GetLandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLandQuery, GetLandQueryVariables>(GetLandDocument, options);
        }
export type GetLandQueryHookResult = ReturnType<typeof useGetLandQuery>;
export type GetLandLazyQueryHookResult = ReturnType<typeof useGetLandLazyQuery>;
export type GetLandQueryResult = Apollo.QueryResult<GetLandQuery, GetLandQueryVariables>;
export const GetNavDocument = gql`
    query GetNav {
  headers(limit: 1) {
    ...RegularHeader
  }
  footers(limit: 1) {
    ...RegularFooter
  }
  categorias(where: {MostrarEnMenu: true}) {
    Nombre
    MostrarEnMenu
    id
  }
}
    ${RegularHeaderFragmentDoc}
${RegularFooterFragmentDoc}`;

/**
 * __useGetNavQuery__
 *
 * To run a query within a React component, call `useGetNavQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNavQuery(baseOptions?: Apollo.QueryHookOptions<GetNavQuery, GetNavQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNavQuery, GetNavQueryVariables>(GetNavDocument, options);
      }
export function useGetNavLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNavQuery, GetNavQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNavQuery, GetNavQueryVariables>(GetNavDocument, options);
        }
export type GetNavQueryHookResult = ReturnType<typeof useGetNavQuery>;
export type GetNavLazyQueryHookResult = ReturnType<typeof useGetNavLazyQuery>;
export type GetNavQueryResult = Apollo.QueryResult<GetNavQuery, GetNavQueryVariables>;
export const GetProductDocument = gql`
    query GetProduct($name: String!) {
  productos(limit: 1, where: {SKU: $name}) {
    ...RegularProducto
  }
}
    ${RegularProductoFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetProductsDocument = gql`
    query GetProducts($limit: Int!, $start: Int = 0, $where: JSON) {
  productos(limit: $limit, start: $start, where: $where) {
    ...RegularProducto
  }
}
    ${RegularProductoFragmentDoc}`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;